import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { User, Mail, Phone, Facebook, Twitter, Linkedin, Instagram, Search, MapPin, Filter, X, } from 'lucide-react';

function WhosWho() {
  const location = useLocation();
  
  // Sample data - replace with actual data from your backend
  const [people] = useState({
    blocksocialaudit: [
       {
      "id": 1,
      "name": "Santwanu Kumar Mohapatra",
      "mobile": "9938856812",
      "block": "BAHANAGA",
      "photo": null,
      "social": {}
    },
       {
      "id": 2,
      "name": "Subhapriya Nayak",
      "mobile": "8260655354",
      "block": "BALESHWAR",
      "photo": null,
      "social": {}
    },
    {
      "id": 3,
      "name": "Sanjib Kumar Jena",
      "mobile": "9040707930",
      "block": "BALIAPAL",
      "photo": null,
      "social": {}
    },
    {
      "id": 4,
      "name": "Pradyumna Acharya",
      "mobile": "8117868618",
      "block": "BASTA",
      "photo": null,
      "social": {}
    },
    {
      "id": 5,
      "name": "Rajat Kumar Nayak",
      "mobile": "8637291028",
      "block": "BHOGRAI",
      "photo": null,
      "social": {}
    },
    {
      "id": 6,
      "name": "Jeeban Krushna Giri",
      "mobile": "7978071815",
      "block": "JALESWAR",
      "photo": null,
      "social": {}
    },
    {
      "id": 7,
      "name": "Hemanta Kumar Parhi",
      "mobile": "7848824019",
      "block": "KHAIRA",
      "photo": null,
      "social": {}
    },
    {
      "id": 8,
      "name": "Satyabrata Mohapatra",
      "mobile": "7789885676",
      "block": "NILGIRI",
      "photo": null,
      "social": {}
    },
    {
      "id": 9,
      "name": "Gouttam Kumar Panda",
      "mobile": "8637259176",
      "block": "OUPADA",
      "photo": null,
      "social": {}
    },
    {
      "id": 10,
      "name": "Alakabala Dey",
      "mobile": "6371420395",
      "block": "REMUNA",
      "photo": null,
      "social": {}
    },
    {
      "id": 11,
      "name": "Surendra Kumar Panda",
      "mobile": "9178085472",
      "block": "SIMULIA",
      "photo": null,
      "social": {}
    },
    {
      "id": 12,
      "name": "Rajat Kumar Muduli",
      "mobile": "8144138109",
      "block": "SORO",
      "photo": null,
      "social": {}
    }
    ],
    vrp: [
     
  {
    "id": 1,
    "name": "Kanchan Lata Behera",
    "email": "kanchanlatabehera355@gmail.com",
    "mobile": "9178757611",
    "block": "SIMULIA",
    "gp": "Markona",
    "photo": null,
    "social": {}
  },
  {
    "id": 2,
    "name": "Pratima Samal",
    "email": "pratimasamal108@gmail.com",
    "mobile": "6371019990",
    "block": "SIMULIA",
    "gp": "Muruna",
    "photo": null,
    "social": {}
  },
  {
    "id": 3,
    "name": "Minarva Mohanty",
    "email": "minarvamohanty4@gmail.com",
    "mobile": "7894410435",
    "block": "SIMULIA",
    "gp": "Shyamasundarpur",
    "photo": null,
    "social": {}
  },
  {
    "id": 4,
    "name": "Jyotsna Rani Bal",
    "email": "jyotsnabal99@gmail.com",
    "mobile": "9178086104",
    "block": "SIMULIA",
    "gp": "Abjhuna",
    "photo": null,
    "social": {}
  },
  {
    "id": 5,
    "name": "Rukmani Barik",
    "email": "barikrukmani764@gmail.com",
    "mobile": "7735663673",
    "block": "SIMULIA",
    "gp": "Bari",
    "photo": null,
    "social": {}
  },
  {
    "id": 6,
    "name": "Bidyutprava Sahoo",
    "email": "sahoobidyutprava933750@gmail.com",
    "mobile": "8658376637",
    "block": "SIMULIA",
    "gp": "Bati",
    "photo": null,
    "social": {}
  },
  {
    "id": 7,
    "name": "Gitarani Nath",
    "email": "muktikantanath73@gmail.com",
    "mobile": "9178085625",
    "block": "SIMULIA",
    "gp": "Pahitorana",
    "photo": null,
    "social": {}
  },
  {
    "id": 8,
    "name": "Ranjita Prusti",
    "email": "ranjitaprusti@gmail.com",
    "mobile": "9556903883",
    "block": "SIMULIA",
    "gp": "Sabanga",
    "photo": null,
    "social": {}
  },
  {
    "id": 9,
    "name": "Sabita Sahu",
    "email": "sahoosabita1985@gmail.com",
    "mobile": "9937210440",
    "block": "SIMULIA",
    "gp": "Pahitorana",
    "photo": null,
    "social": {}
  },
  {
    "id": 10,
    "name": "Pratima Padhi",
    "email": "ankitpadhi43279@gmail.com",
    "mobile": "8895479419",
    "block": "SIMULIA",
    "gp": "Anandapur",
    "photo": null,
    "social": {}
  },
  {
    "id": 11,
    "name": "Narmada Das",
    "email": "narmadadas721@gmail.com",
    "mobile": "9348418957",
    "block": "SIMULIA",
    "gp": "Maitapur",
    "photo": null,
    "social": {}
  },
  {
    "id": 12,
    "name": "Rashmita Mishra",
    "email": "",
    "mobile": "9778726515",
    "block": "SIMULIA",
    "gp": "Abjhuna",
    "photo": null,
    "social": {}
  },
  {
    "id": 13,
    "name": "Jayanti Barik",
    "email": "barikprahallad960@gmail.com",
    "mobile": "9853306901",
    "block": "SIMULIA",
    "gp": "Bangalpur",
    "photo": null,
    "social": {}
  },
  {
    "id": 14,
    "name": "Bidyabati Jena",
    "email": "bidyabati29@gmail.com",
    "mobile": "9777765265",
    "block": "SIMULIA",
    "gp": "Bauripada",
    "photo": null,
    "social": {}
  },
  {
    "id": 15,
    "name": "Saraswati Sahoo",
    "email": "sahoosaraswati926@gmail.com",
    "mobile": "8144804853",
    "block": "SIMULIA",
    "gp": "Bari",
    "photo": null,
    "social": {}
  },
  {
    "id": 16,
    "name": "Santilata Shial",
    "email": "bhabanishial223@gmail.com",
    "mobile": "8144393884",
    "block": "SIMULIA",
    "gp": "Purusottampur",
    "photo": null,
    "social": {}
  },
  {
    "id": 17,
    "name": "Maheswata Parhi",
    "email": "maheswataparhi79@gmail.com",
    "mobile": "9938040789",
    "block": "SIMULIA",
    "gp": "Kanheibindha",
    "photo": null,
    "social": {}
  },
  {
    "id": 18,
    "name": "Babirani Kunar",
    "email": "babirani1978@gmail.com",
    "mobile": "7853971686",
    "block": "SIMULIA",
    "gp": "Kanchapada",
    "photo": null,
    "social": {}
  },
  {
    "id": 19,
    "name": "Bijayalaxmi Sahu",
    "email": "sahubijayalaxmi087@gmail.com",
    "mobile": "7894943663",
    "block": "SIMULIA",
    "gp": "Bangarkhadigadia",
    "photo": null,
    "social": {}
  },
  {
    "id": 20,
    "name": "Soudamini Sahu",
    "email": "saudaminsahoo124@gmail.com",
    "mobile": "6371575873",
    "block": "SIMULIA",
    "gp": "Jamujhadi",
    "photo": null,
    "social": {}
  },
  {
    "id": 21,
    "name": "KABITA RANI DASH ",
    "email": "dashkabitarani43@gmail.com",
    "mobile": "8356015540",
    "block": "SORO",
    "gp": "ATTAPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 22,
    "name": "SANJULATA MALIK",
    "email": "swagatikamalik955@gmail.com",
    "mobile": "9556843948",
    "block": "SORO",
    "gp": "JADIDA",
    "photo": null,
    "social": {}
  },
  {
    "id": 23,
    "name": "LAXMI PRIYA MAHARANA",
    "email": "laxmipriyamaharana696@gmail.com",
    "mobile": "7327004754",
    "block": "SORO",
    "gp": "KESHARIPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 24,
    "name": "RASMITA BARIK",
    "email": "rasmitabarik413@gmail.com",
    "mobile": "7735686048",
    "block": "SORO",
    "gp": "MULISING",
    "photo": null,
    "social": {}
  },
  {
    "id": 25,
    "name": "MANDAKINI JENA",
    "email": "jenamandakini2906@gmail.com",
    "mobile": "7735956306",
    "block": "SORO",
    "gp": "MANATRI",
    "photo": null,
    "social": {}
  },
  {
    "id": 26,
    "name": "MANORAMA JENA",
    "email": "manoramaj70@gmail.com",
    "mobile": "7855964474",
    "block": "SORO",
    "gp": "GUD",
    "photo": null,
    "social": {}
  },
  {
    "id": 27,
    "name": "SEBATI LATA PARHI",
    "email": "silisilipanda@gmail.com",
    "mobile": "9556946193",
    "block": "SORO",
    "gp": "GUD",
    "photo": null,
    "social": {}
  },
  {
    "id": 28,
    "name": "SUBHASMITA DAS",
    "email": "dsubhasmita379@gmail.com",
    "mobile": "9861106678",
    "block": "SORO",
    "gp": "DAHISADA ",
    "photo": null,
    "social": {}
  },
  {
    "id": 29,
    "name": "SABITRI MALLICK",
    "email": "biswannathmallick626@gmail.com",
    "mobile": "7205343890",
    "block": "SORO",
    "gp": "GUD",
    "photo": null,
    "social": {}
  },
  {
    "id": 30,
    "name": "PRATIVA BISWAL",
    "email": "prativabiswal160@gmail.com",
    "mobile": "7894162839",
    "block": "SORO",
    "gp": "GOPINATHPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 31,
    "name": "ALAKA RANI MOHAPATRA",
    "email": "alakaranimohapatra1@gmail.com",
    "mobile": "9692917365",
    "block": "SORO",
    "gp": "TALANAGAR",
    "photo": null,
    "social": {}
  },
  {
    "id": 32,
    "name": "MANORAMA SAHU",
    "email": "manorama774@gmail.com",
    "mobile": "9337644452",
    "block": "SORO",
    "gp": "MANATRI",
    "photo": null,
    "social": {}
  },
  {
    "id": 33,
    "name": "SARASWATI MAJHI ",
    "email": "majhisaraswati2234@gmail.com",
    "mobile": "6352363911",
    "block": "SORO ",
    "gp": "TALANAGAR",
    "photo": null,
    "social": {}
  },
  {
    "id": 34,
    "name": "KHULANABATI BEHERA",
    "email": "khulanabatibehera2331@gmail.com",
    "mobile": "7735703250",
    "block": "SORO ",
    "gp": "NATAPADA",
    "photo": null,
    "social": {}
  },
  {
    "id": 35,
    "name": "HARAPRIYA NAYAK",
    "email": "lipinayak65@gmail.com",
    "mobile": "7978084178",
    "block": "NILGIRI",
    "gp": "JADIDA",
    "photo": null,
    "social": {}
  },
  {
    "id": 36,
    "name": "MAMATA BEHERA",
    "email": "beherabirendra222@gmail.com",
    "mobile": "9937644602",
    "block": "NILGIRI",
    "gp": "MAHINSAPATA ",
    "photo": null,
    "social": {}
  },
  {
    "id": 37,
    "name": "MAMATA ROUT",
    "email": "mamatarout6331@gmail.com",
    "mobile": "9556206331",
    "block": "NILGIRI",
    "gp": "PITHAHATA",
    "photo": null,
    "social": {}
  },
  {
    "id": 38,
    "name": "JAYANTI JENA",
    "email": "jayantijena73285@gmail.com",
    "mobile": "7440191440",
    "block": "NILGIRI",
    "gp": "MATIALI",
    "photo": null,
    "social": {}
  },
  {
    "id": 39,
    "name": "SANJUKTA BEHERA",
    "email": "bsanjukta842@gmail.com",
    "mobile": "9124968617",
    "block": "NILGIRI",
    "gp": "DHARAMPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 40,
    "name": "PRAMILA NAYAK",
    "email": "pramilanayam2024@gmail.com",
    "mobile": "9861239398",
    "block": "NILGIRI",
    "gp": "B.BAD",
    "photo": null,
    "social": {}
  },
  {
    "id": 41,
    "name": "RASHMITA NAYAK",
    "email": "nrashmita96@gmail.com",
    "mobile": "8260398453",
    "block": "NILGIRI",
    "gp": "R.K.PUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 42,
    "name": "DIPANJALI PRADHAN DALAI",
    "email": "deepanjalipradhandalai1@gmail.com",
    "mobile": "9692729359",
    "block": "NILGIRI",
    "gp": "CHATRAPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 43,
    "name": "PUSPANJALI NAYAK",
    "email": "puspanjalinayak363@gmail.com",
    "mobile": "6370720659",
    "block": "NILGIRI",
    "gp": "K.P.LAKHARAJ",
    "photo": null,
    "social": {}
  },
  {
    "id": 44,
    "name": "JYOSTHNA RANI NAYAK",
    "email": "nayakjyotsnarani109@gmail.com",
    "mobile": "8658299338",
    "block": "NILGIRI",
    "gp": "TENTULIA",
    "photo": null,
    "social": {}
  },
  {
    "id": 45,
    "name": "DRAUPADI MAHALIK",
    "email": "draupad786@gmail.com",
    "mobile": "7077539636",
    "block": "NILGIRI",
    "gp": "KANSA",
    "photo": null,
    "social": {}
  },
  {
    "id": 46,
    "name": "MANORAMA MISHRA",
    "email": "mishrahemanta210@gmail.com",
    "mobile": "6370606009",
    "block": "NILGIRI",
    "gp": "TELIPAL",
    "photo": null,
    "social": {}
  },
  {
    "id": 47,
    "name": "ANITA BISWAL",
    "email": "ajena7078@gmail.com",
    "mobile": "9337604254",
    "block": "NILGIRI",
    "gp": "JAMUDHIA",
    "photo": null,
    "social": {}
  },
  {
    "id": 48,
    "name": "PADMINI SINGH",
    "email": "",
    "mobile": "9337704187",
    "block": "NILGIRI",
    "gp": "SIADIMAL",
    "photo": null,
    "social": {}
  },
  {
    "id": 49,
    "name": "SHARMILA BAG",
    "email": "parameswarbag301@gmail.com",
    "mobile": "9556824013",
    "block": "NILGIRI",
    "gp": "CHATRAPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 50,
    "name": "RANJULATA BEHERA",
    "email": "bhaktibehera2010@gmail.com",
    "mobile": "6372171301",
    "block": "NILGIRI",
    "gp": "BERHAMPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 51,
    "name": "MAMATARANI MAHANNA",
    "email": "mamataranimahanna10@gmail.com",
    "mobile": "8339079979",
    "block": "NILGIRI",
    "gp": "K.P.LAKHARAJ",
    "photo": null,
    "social": {}
  },
  {
    "id": 52,
    "name": "KABITA MUKHI",
    "email": "kabitamukhi35@gmail.com",
    "mobile": "9348002868",
    "block": "NILGIRI",
    "gp": "AJODHYA",
    "photo": null,
    "social": {}
  },
  {
    "id": 53,
    "name": "SABITRI MARANDI",
    "email": "marandibikash964@gmail.com",
    "mobile": "7381306553",
    "block": "NILGIRI",
    "gp": "SAJANAGARH",
    "photo": null,
    "social": {}
  },
  {
    "id": 54,
    "name": "DAMAYANTI JENA",
    "email": "damayantijena199508@gmail.com",
    "mobile": "8908344579",
    "block": "BAHANAGA",
    "gp": "BAHANAGA",
    "photo": null,
    "social": {}
  },
  {
    "id": 55,
    "name": "DEBAPRAVA KHATUA",
    "email": "dabapravakhatua86@gmail.com",
    "mobile": "7873093385",
    "block": "BAHANAGA",
    "gp": "ARUHABAD",
    "photo": null,
    "social": {}
  },
  {
    "id": 56,
    "name": "GITANJALI PANDA",
    "email": "gitanjali.panda779@gmail.com",
    "mobile": "8658425725",
    "block": "BAHANAGA",
    "gp": "ANJI",
    "photo": null,
    "social": {}
  },
  {
    "id": 57,
    "name": "MITANJALI NAYAK",
    "email": "mitanjalin488@gmail.com",
    "mobile": "8018089408",
    "block": "BAHANAGA",
    "gp": "ANJI",
    "photo": null,
    "social": {}
  },
  {
    "id": 58,
    "name": "MAMATA BEHERA",
    "email": "mb4689511@gmail.com",
    "mobile": "8455927981",
    "block": "BAHANAGA",
    "gp": "ANJI",
    "photo": null,
    "social": {}
  },
  {
    "id": 59,
    "name": "SABITA PALAI",
    "email": "patraananta7978@gmail.com",
    "mobile": "7008846755",
    "block": "BAHANAGA",
    "gp": "CHITTOL",
    "photo": null,
    "social": {}
  },
  {
    "id": 60,
    "name": "SOUDAMINI ROUT",
    "email": "routarchita70@gmail.com",
    "mobile": "8658363508",
    "block": "BAHANAGA",
    "gp": "KASABAJAYPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 61,
    "name": "SUKANTI BHOL",
    "email": "sukantimanas5@gmail.com",
    "mobile": "7327993044",
    "block": "BAHANAGA",
    "gp": "C.JAGANNATHAPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 62,
    "name": "JHARANA SAHU",
    "email": "rs0196188@gmail.com",
    "mobile": "9938407688",
    "block": "BAHANAGA",
    "gp": "TALAKURUNIA",
    "photo": null,
    "social": {}
  },
  {
    "id": 63,
    "name": "MALATI DAS",
    "email": "dasmalati798@gmail.come",
    "mobile": "7853922295",
    "block": "BAHANAGA",
    "gp": "NUAPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 64,
    "name": "BIDYUT PRABHA MAHALIK",
    "email": "mahalikbidyutprava@gmail.com",
    "mobile": "9777306218",
    "block": "BAHANAGA",
    "gp": "KHARASAHAPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 65,
    "name": "RITARANI LENKA",
    "email": "jashobantalenka99@gmail.com",
    "mobile": "9776161784",
    "block": "BAHANAGA",
    "gp": "KASABAJAYPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 66,
    "name": "SULOCHANA BEHERA",
    "email": "sulochanabehera.12@gmail.com",
    "mobile": "8458020211",
    "block": "BAHANAGA",
    "gp": "ANJI",
    "photo": null,
    "social": {}
  },
  {
    "id": 67,
    "name": "NIRUPAMA NAYAK",
    "email": "bibhutinayak011@gmail.com",
    "mobile": "9348215047",
    "block": "BAHANAGA",
    "gp": "ANJI",
    "photo": null,
    "social": {}
  },
  {
    "id": 68,
    "name": "Rajeswari Pradhan",
    "email": "",
    "mobile": "7853995565",
    "block": "BALIAPAL",
    "gp": "Debhog",
    "photo": null,
    "social": {}
  },
  {
    "id": 69,
    "name": "Rasmita Pradhan",
    "email": "rasmita patra174@gmail.com",
    "mobile": "7205379703",
    "block": "BALIAPAL",
    "gp": "Asti",
    "photo": null,
    "social": {}
  },
  {
    "id": 70,
    "name": "Sandhya Rani Patra",
    "email": "sandhyaranipatra116@gamial.com",
    "mobile": "9777977495",
    "block": "BALIAPAL",
    "gp": "BALIAPAL",
    "photo": null,
    "social": {}
  },
  {
    "id": 71,
    "name": "Kalpana Mohapatra ",
    "email": "kalpanamohapatra014@gmail.com",
    "mobile": "6371197690",
    "block": "BALIAPAL",
    "gp": "Kumbhari",
    "photo": null,
    "social": {}
  },
  {
    "id": 72,
    "name": "Hiramani Barik ",
    "email": "hiramanibarik6@gmail.com",
    "mobile": "9556431466",
    "block": "BALIAPAL",
    "gp": "Betagadia ",
    "photo": null,
    "social": {}
  },
  {
    "id": 73,
    "name": "Sasmita Kar",
    "email": "sasmitasamal6622@gmail.com",
    "mobile": "9566703934",
    "block": "BALIAPAL",
    "gp": "Asti",
    "photo": null,
    "social": {}
  },
  {
    "id": 74,
    "name": "Ranjita Patra",
    "email": "rrp23260@gmail.com",
    "mobile": "8144364657",
    "block": "BALIAPAL",
    "gp": "Badas",
    "photo": null,
    "social": {}
  },
  {
    "id": 75,
    "name": "Ranjita Das",
    "email": "mrs.ranjitanayak07@gmail.com",
    "mobile": "6371630761",
    "block": "BALIAPAL",
    "gp": "Kunduli",
    "photo": null,
    "social": {}
  },
  {
    "id": 76,
    "name": "Gitanjali Rout",
    "email": "krout0836@gmail.com",
    "mobile": "7749097347",
    "block": "BALIAPAL            ",
    "gp": "Jambhirai     ",
    "photo": null,
    "social": {}
  },
  {
    "id": 77,
    "name": "Champabati Giri",
    "email": "champabatigiri@gmail.com",
    "mobile": "9237988614",
    "block": "BALIAPAL",
    "gp": "Asti",
    "photo": null,
    "social": {}
  },
  {
    "id": 78,
    "name": "Jayanti Das",
    "email": "",
    "mobile": "9040285546",
    "block": "BALIAPAL",
    "gp": "Jamkunda",
    "photo": null,
    "social": {}
  },
  {
    "id": 79,
    "name": "Hiramani Das",
    "email": "",
    "mobile": "9237559711",
    "block": "BALIAPAL            ",
    "gp": "Betagadia ",
    "photo": null,
    "social": {}
  },
  {
    "id": 80,
    "name": "Snehanjali Jena",
    "email": "",
    "mobile": "7609015084",
    "block": "BALIAPAL",
    "gp": "Asti",
    "photo": null,
    "social": {}
  },
  {
    "id": 81,
    "name": "Chandini Mukhi",
    "email": "",
    "mobile": "8598859625",
    "block": "BALIAPAL",
    "gp": "Balarampur",
    "photo": null,
    "social": {}
  },
  {
    "id": 82,
    "name": "Sakuntala Jena",
    "email": "sethisakuntalads@gmail.com",
    "mobile": "9556772642",
    "block": "BALIAPAL            ",
    "gp": "Kunduli",
    "photo": null,
    "social": {}
  },
  {
    "id": 83,
    "name": "Anjali Patra",
    "email": "anjalipatra286@gmail.com",
    "mobile": "8984137445",
    "block": "BALIAPAL",
    "gp": "Baniadiha",
    "photo": null,
    "social": {}
  },
  {
    "id": 84,
    "name": "Sasmita Nayak",
    "email": "hhemantanayak794@gmail.com",
    "mobile": "8328861350",
    "block": "BALIAPAL",
    "gp": "Deula",
    "photo": null,
    "social": {}
  },
  {
    "id": 85,
    "name": "Namita Mohapatra",
    "email": "",
    "mobile": "9692842420",
    "block": "BALIAPAL            ",
    "gp": "Kumbhari",
    "photo": null,
    "social": {}
  },
  {
    "id": 86,
    "name": "Basanti Jena",
    "email": "dasrabindra508@gmail.com",
    "mobile": "6372670360",
    "block": "BALIAPAL",
    "gp": "Dagara",
    "photo": null,
    "social": {}
  },
  {
    "id": 87,
    "name": "Indumati Giri",
    "email": "raghugiri988@gmail.com",
    "mobile": "9777482400",
    "block": "BALIAPAL",
    "gp": "Panchupali",
    "photo": null,
    "social": {}
  },
  {
    "id": 88,
    "name": "Pramila Das",
    "email": "daspramila788@gmail.com",
    "mobile": "7852975603",
    "block": "BALIAPAL            ",
    "gp": "Pratappur",
    "photo": null,
    "social": {}
  },
  {
    "id": 89,
    "name": "Laxmipriya Padhiray",
    "email": "",
    "mobile": "9777179285",
    "block": "BALIAPAL",
    "gp": "Aladiha",
    "photo": null,
    "social": {}
  },
  {
    "id": 90,
    "name": "kabita Giri",
    "email": "",
    "mobile": "9178410228",
    "block": "BALIAPAL",
    "gp": "Baniadiha",
    "photo": null,
    "social": {}
  },
  {
    "id": 91,
    "name": "Trupti Mayi Barik",
    "email": "",
    "mobile": "7854079482",
    "block": "BALIAPAL            ",
    "gp": "Ratai",
    "photo": null,
    "social": {}
  },
  {
    "id": 92,
    "name": "Bimala Pani",
    "email": "",
    "mobile": "7873981422",
    "block": "BALIAPAL",
    "gp": "Jagatipur",
    "photo": null,
    "social": {}
  },
  {
    "id": 93,
    "name": "Rina Rani Biswal",
    "email": "anilkumarb293@gmail.com",
    "mobile": "6370750728",
    "block": "BALIAPAL",
    "gp": "Srirampur",
    "photo": null,
    "social": {}
  },
  {
    "id": 94,
    "name": "Shanti Lata Jena",
    "email": "shantilata174@gmail.com",
    "mobile": "9937289024",
    "block": "BALIAPAL            ",
    "gp": "Jagatipur",
    "photo": null,
    "social": {}
  },
  {
    "id": 95,
    "name": "GITANJALI NAYAK",
    "email": "",
    "mobile": "6371877967",
    "block": "KHAIRA",
    "gp": "AMARIA-AGNIPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 96,
    "name": "SUBHASMITA PANDA",
    "email": "",
    "mobile": "7377686048",
    "block": "KHAIRA",
    "gp": "BADAJAYPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 97,
    "name": "NIBEDITA GADAPALLA MOHAPATRA",
    "email": "",
    "mobile": "9777071890",
    "block": "KHAIRA",
    "gp": "BADAJAYPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 98,
    "name": "KSHIRABDHI TANAYA MOHAPATRA",
    "email": "",
    "mobile": "7848855308",
    "block": "KHAIRA",
    "gp": "BADANUAGAON",
    "photo": null,
    "social": {}
  },
  {
    "id": 99,
    "name": "MENAKARANI JENA",
    "email": "",
    "mobile": "7077303850",
    "block": "KHAIRA",
    "gp": "GARASANG",
    "photo": null,
    "social": {}
  },
  {
    "id": 100,
    "name": "NA ARPITA BEHERA",
    "email": "",
    "mobile": "9556682736",
    "block": "KHAIRA",
    "gp": "SHYAMSUNDARPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 101,
    "name": "MAMATA DASH",
    "email": "",
    "mobile": "8895297148",
    "block": "KHAIRA",
    "gp": "HARIPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 102,
    "name": "MONALISHA DAS",
    "email": "",
    "mobile": "6370632729",
    "block": "KHAIRA",
    "gp": "MANATRI",
    "photo": null,
    "social": {}
  },
  {
    "id": 103,
    "name": "NANDITA KHUNTIA",
    "email": "",
    "mobile": "7853033612",
    "block": "KHAIRA",
    "gp": "GOBINDPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 104,
    "name": "SASWATI DAS",
    "email": "",
    "mobile": "9178068816",
    "block": "KHAIRA",
    "gp": "ACHYUTPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 105,
    "name": "SASMITA KUNDU",
    "email": "",
    "mobile": "6372932312",
    "block": "KHAIRA",
    "gp": "GADAPOKHARI",
    "photo": null,
    "social": {}
  },
  {
    "id": 106,
    "name": "ANUPAMA BEHERA",
    "email": "",
    "mobile": "7894546975",
    "block": "KHAIRA",
    "gp": "DALANG-2",
    "photo": null,
    "social": {}
  },
  {
    "id": 107,
    "name": "KABITA PARIDA",
    "email": "",
    "mobile": "7735949339",
    "block": "KHAIRA",
    "gp": "NANDOR",
    "photo": null,
    "social": {}
  },
  {
    "id": 108,
    "name": "HARAPRIYA NAYAK",
    "email": "",
    "mobile": "9348013317",
    "block": "KHAIRA",
    "gp": "MANITRI",
    "photo": null,
    "social": {}
  },
  {
    "id": 109,
    "name": "BINAPANI BEHERA",
    "email": "",
    "mobile": "9938346118",
    "block": "KHAIRA",
    "gp": "PALASA",
    "photo": null,
    "social": {}
  },
  {
    "id": 110,
    "name": "SANJULATA DASH",
    "email": "",
    "mobile": "9078519337",
    "block": "KHAIRA",
    "gp": "BARTANA",
    "photo": null,
    "social": {}
  },
  {
    "id": 111,
    "name": "PRAMILA JENA",
    "email": "",
    "mobile": "9938297589",
    "block": "KHAIRA",
    "gp": "KAITHAGADIA",
    "photo": null,
    "social": {}
  },
  {
    "id": 112,
    "name": "URMILA SWAIN ",
    "email": "",
    "mobile": "9583550820",
    "block": "KHAIRA",
    "gp": "PALASA",
    "photo": null,
    "social": {}
  },
  {
    "id": 113,
    "name": "ANUPAMA BARIK",
    "email": "",
    "mobile": "8093682211",
    "block": "KHAIRA",
    "gp": "BADAJAYPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 114,
    "name": "JAYANTI MANI BARIK",
    "email": "",
    "mobile": "7750032708",
    "block": "KHAIRA",
    "gp": "ANTARA",
    "photo": null,
    "social": {}
  },
  {
    "id": 115,
    "name": "GITAPRAVASINI PADHI",
    "email": "",
    "mobile": "7751946936",
    "block": "KHAIRA",
    "gp": "KURUNTA",
    "photo": null,
    "social": {}
  },
  {
    "id": 116,
    "name": "SULOCHANA KHILAR",
    "email": "",
    "mobile": "9692959009",
    "block": "KHAIRA",
    "gp": "KHAIRA",
    "photo": null,
    "social": {}
  },
  {
    "id": 117,
    "name": "JYOTI PRIYA GIRI",
    "email": "",
    "mobile": "9040378880",
    "block": "KHAIRA",
    "gp": "MAHATIPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 118,
    "name": "TAPASWINI BEHERA",
    "email": "",
    "mobile": "9668302056",
    "block": "KHAIRA",
    "gp": "JHINKIRIA",
    "photo": null,
    "social": {}
  },
  {
    "id": 119,
    "name": "SANTILATA KANDI",
    "email": "",
    "mobile": "7606820895",
    "block": "KHAIRA",
    "gp": "GARSANG",
    "photo": null,
    "social": {}
  },
  {
    "id": 120,
    "name": "MALATILATA BEHERA",
    "email": "",
    "mobile": "9348536428",
    "block": "KHAIRA",
    "gp": "SARAKONA",
    "photo": null,
    "social": {}
  },
  {
    "id": 121,
    "name": "RASHMIREKHA LENKA",
    "email": "",
    "mobile": "6371105082",
    "block": "KHAIRA",
    "gp": "SARDANGA",
    "photo": null,
    "social": {}
  },
  {
    "id": 122,
    "name": "LABANYABATI DHAL",
    "email": "",
    "mobile": "8457944368",
    "block": "KHAIRA",
    "gp": "KUPARI",
    "photo": null,
    "social": {}
  },
  {
    "id": 123,
    "name": "DEBAKI PANDA",
    "email": "",
    "mobile": "7205606562",
    "block": "KHAIRA",
    "gp": "RATINA",
    "photo": null,
    "social": {}
  },
  {
    "id": 124,
    "name": "LIPIKA MOHANTY",
    "email": "",
    "mobile": "8658272254",
    "block": "KHAIRA",
    "gp": "BARADA",
    "photo": null,
    "social": {}
  },
  {
    "id": 125,
    "name": "SASMITA SA",
    "email": "",
    "mobile": "7008159565",
    "block": "KHAIRA",
    "gp": "NAYAKHANDI",
    "photo": null,
    "social": {}
  },
  {
    "id": 126,
    "name": "SMRUTIREKHA PARHI",
    "email": "",
    "mobile": "9337265546",
    "block": "KHAIRA",
    "gp": "DAGARPADA",
    "photo": null,
    "social": {}
  },
  {
    "id": 127,
    "name": "PRABHATI DAS",
    "email": "",
    "mobile": "9556599224",
    "block": "KHAIRA",
    "gp": "SUNDHIRAGANDIBED",
    "photo": null,
    "social": {}
  },
  {
    "id": 128,
    "name": "GAYATRI BEJ",
    "email": "",
    "mobile": "8018397971",
    "block": "KHAIRA",
    "gp": "ANTARA",
    "photo": null,
    "social": {}
  },
  {
    "id": 129,
    "name": "BASANTI SA",
    "email": "",
    "mobile": "7077960426",
    "block": "KHAIRA",
    "gp": "GADAPOKHARI",
    "photo": null,
    "social": {}
  },
  {
    "id": 130,
    "name": "SULOCHANA SAHU",
    "email": "",
    "mobile": "6370442643",
    "block": "KHAIRA",
    "gp": "GOLIHA",
    "photo": null,
    "social": {}
  },
  {
    "id": 131,
    "name": "BINODINI JENA",
    "email": "",
    "mobile": "6371709175",
    "block": "KHAIRA",
    "gp": "NAHANGA",
    "photo": null,
    "social": {}
  },
  {
    "id": 132,
    "name": "JASODA NAYAK",
    "email": "",
    "mobile": "7606927816",
    "block": "KHAIRA",
    "gp": "KAITHAGADIA",
    "photo": null,
    "social": {}
  },
  {
    "id": 133,
    "name": "MADHUSMITA SINGH",
    "email": "",
    "mobile": "7381464119",
    "block": "KHAIRA",
    "gp": "SUNDHIRAGANDIBED",
    "photo": null,
    "social": {}
  },
  {
    "id": 134,
    "name": "Anupama Das",
    "email": "anupamaprusty82@gmail.com",
    "mobile": "9348050751",
    "block": "REMUNA",
    "gp": "Srikrushnapur",
    "photo": null,
    "social": {}
  },
  {
    "id": 135,
    "name": "Sasmita Sethi",
    "email": "rina sasmita 9040@gmail.com",
    "mobile": "8114792656",
    "block": "REMUNA",
    "gp": "Kuruda",
    "photo": null,
    "social": {}
  },
  {
    "id": 136,
    "name": "Mamata Jena",
    "email": "mamatajenam90@gmail.com",
    "mobile": "6372038637",
    "block": "REMUNA",
    "gp": "Maharajpur",
    "photo": null,
    "social": {}
  },
  {
    "id": 137,
    "name": "Gitanjali Hota",
    "email": "ghota54@gmail.com",
    "mobile": "8908394005",
    "block": "REMUNA",
    "gp": "Barunasing",
    "photo": null,
    "social": {}
  },
  {
    "id": 138,
    "name": "Laxmipriya Mohanty",
    "email": "mamimohanty5@gmail.com",
    "mobile": "9040577388",
    "block": "REMUNA",
    "gp": "Nizampur",
    "photo": null,
    "social": {}
  },
  {
    "id": 139,
    "name": "Narmada Mallik",
    "email": "narmadamalik13@abdm",
    "mobile": "6371751147",
    "block": "REMUNA",
    "gp": "Bahal",
    "photo": null,
    "social": {}
  },
  {
    "id": 140,
    "name": "Abanti Swain",
    "email": "abantiswain106@gmail.com",
    "mobile": "9437967598",
    "block": "REMUNA",
    "gp": "Nuagan",
    "photo": null,
    "social": {}
  },
  {
    "id": 141,
    "name": "Basanti Behera",
    "email": "behera basanti 572@gmail.com",
    "mobile": "8917271911",
    "block": "REMUNA",
    "gp": "Biruan",
    "photo": null,
    "social": {}
  },
  {
    "id": 142,
    "name": "Anupama Mallik",
    "email": "manupama226@gmail.com",
    "mobile": "9668600860",
    "block": "REMUNA",
    "gp": "Kuligan",
    "photo": null,
    "social": {}
  },
  {
    "id": 143,
    "name": "Sasmita Jena",
    "email": "jsasmita9796@gmail.com",
    "mobile": "9337384526",
    "block": "REMUNA",
    "gp": "Saraswatipur",
    "photo": null,
    "social": {}
  },
  {
    "id": 144,
    "name": "Pramila Behera",
    "email": "bpramila 142@gmail.com",
    "mobile": "9938458417",
    "block": "REMUNA",
    "gp": "Bhimpura",
    "photo": null,
    "social": {}
  },
  {
    "id": 145,
    "name": "Sanjulata Majhi",
    "email": "sanjulatamajhi5@gimail.com",
    "mobile": "8908318252",
    "block": "REMUNA",
    "gp": "Kalyanpur",
    "photo": null,
    "social": {}
  },
  {
    "id": 146,
    "name": "Rukmani Mahalik",
    "email": "mahalik82rukmani@gmail.com",
    "mobile": "8118082950",
    "block": "REMUNA",
    "gp": "Barunsing",
    "photo": null,
    "social": {}
  },
  {
    "id": 147,
    "name": "Kaberi Mahalik",
    "email": "kaberimahalik8342@gmail.com",
    "mobile": "8328920110",
    "block": "REMUNA",
    "gp": "Dahapada",
    "photo": null,
    "social": {}
  },
  {
    "id": 148,
    "name": "Bhabani Malik",
    "email": "bhabanimalik480@gmail.com",
    "mobile": "8338851531",
    "block": "REMUNA",
    "gp": "Kuruda",
    "photo": null,
    "social": {}
  },
  {
    "id": 149,
    "name": "Ananya Basak",
    "email": "basak ananya 96 @ gmail.com",
    "mobile": "7848936344",
    "block": "REMUNA",
    "gp": "Balia",
    "photo": null,
    "social": {}
  },
  {
    "id": 150,
    "name": "Sabita Behera",
    "email": "sabitabehera92b1@gmail.com",
    "mobile": "9337410471",
    "block": "REMUNA",
    "gp": "Tundara",
    "photo": null,
    "social": {}
  },
  {
    "id": 151,
    "name": "Chitra Parida",
    "email": "chitraparida 11@gmail.com",
    "mobile": "7853992850",
    "block": "REMUNA",
    "gp": "REMUNA",
    "photo": null,
    "social": {}
  },
  {
    "id": 152,
    "name": "Nishiswapna Senapati",
    "email": "senapatinishiswapna@gmail.com",
    "mobile": "7735935851",
    "block": "REMUNA",
    "gp": "Nizampur",
    "photo": null,
    "social": {}
  },
  {
    "id": 153,
    "name": "Chandra Kanti Jena",
    "email": "chandrakanti jena77@gmail.com",
    "mobile": "6372486938",
    "block": "REMUNA",
    "gp": "Nuagan",
    "photo": null,
    "social": {}
  },
  {
    "id": 154,
    "name": "Bharati Behera",
    "email": "behera bharati 525@gmail.com",
    "mobile": "8895487414",
    "block": "REMUNA",
    "gp": "Gandarda",
    "photo": null,
    "social": {}
  },
  {
    "id": 155,
    "name": "Basanti Barik",
    "email": "barikbasanti80@gmail.com",
    "mobile": "9777066836",
    "block": "REMUNA",
    "gp": "Sergarh",
    "photo": null,
    "social": {}
  },
  {
    "id": 156,
    "name": "Tulashi Pattanayak",
    "email": "tulasipattan@gmail.com",
    "mobile": "8260831223",
    "block": "REMUNA",
    "gp": "Patripal",
    "photo": null,
    "social": {}
  },
  {
    "id": 157,
    "name": "Jhunumani Das",
    "email": "dasjhunumani69@gmail.com",
    "mobile": "7608045392",
    "block": "REMUNA",
    "gp": "Mandarpur",
    "photo": null,
    "social": {}
  },
  {
    "id": 158,
    "name": "Laxmi Mani Pradhan",
    "email": "laxmimanipradhan1981@gmail.com",
    "mobile": "9861029605",
    "block": "REMUNA",
    "gp": "Gandarda",
    "photo": null,
    "social": {}
  },
  {
    "id": 159,
    "name": "Kunjalata Sethi",
    "email": "",
    "mobile": "80180089620",
    "block": "REMUNA",
    "gp": "Chasakhand",
    "photo": null,
    "social": {}
  },
  {
    "id": 160,
    "name": "Pramita Das",
    "email": "pramitadas51@gmail.com",
    "mobile": "8093398603",
    "block": "REMUNA",
    "gp": "Mandarpur",
    "photo": null,
    "social": {}
  },
  {
    "id": 161,
    "name": "Puspalata Mallik",
    "email": "puspalata mallik 529@gmail.com",
    "mobile": "6370900019",
    "block": "REMUNA",
    "gp": "Badapal",
    "photo": null,
    "social": {}
  },
  {
    "id": 162,
    "name": "Prapita Pradhan",
    "email": "prapita20pradhan@gmail.com",
    "mobile": "8260480400",
    "block": "REMUNA",
    "gp": "Badapal",
    "photo": null,
    "social": {}
  },
  {
    "id": 163,
    "name": "Sumati Rout",
    "email": "routsumati524@gmail.com",
    "mobile": "7978845791",
    "block": "BASTA",
    "gp": "Natakata ",
    "photo": null,
    "social": {}
  },
  {
    "id": 164,
    "name": "Sitarani Giri",
    "email": "sitaranigiri99@gmail.com",
    "mobile": "8144795772",
    "block": "BASTA",
    "gp": "Natakata ",
    "photo": null,
    "social": {}
  },
  {
    "id": 165,
    "name": "Sabita Behera",
    "email": "sabitabehra2940@gmail.com ",
    "mobile": "7325886696",
    "block": "BASTA",
    "gp": "Kulida",
    "photo": null,
    "social": {}
  },
  {
    "id": 166,
    "name": "Sanjulata Nayak",
    "email": "gourabsankarnayak@gmail.com ",
    "mobile": "9178035354",
    "block": "BASTA",
    "gp": "Kulida",
    "photo": null,
    "social": {}
  },
  {
    "id": 167,
    "name": "Sankutala Parida",
    "email": "",
    "mobile": "8117957510",
    "block": "BASTA",
    "gp": "Barunagadia",
    "photo": null,
    "social": {}
  },
  {
    "id": 168,
    "name": "Mamata Senapati",
    "email": "mamatasenapati67895@gmail.com ",
    "mobile": "7854935070",
    "block": "BASTA",
    "gp": "Barunagadia",
    "photo": null,
    "social": {}
  },
  {
    "id": 169,
    "name": "Ranjita Das",
    "email": "ranjitadas80188@gmail.com ",
    "mobile": "8018850084",
    "block": "BASTA",
    "gp": "Kudia",
    "photo": null,
    "social": {}
  },
  {
    "id": 170,
    "name": "Santilata Gan",
    "email": "santilatagan10@gmail.com",
    "mobile": "7008404360",
    "block": "BASTA",
    "gp": "Barada",
    "photo": null,
    "social": {}
  },
  {
    "id": 171,
    "name": "Puspalata Gan",
    "email": "puspalatagan480@gmail.com",
    "mobile": "7894068880",
    "block": "BASTA",
    "gp": "Barada",
    "photo": null,
    "social": {}
  },
  {
    "id": 172,
    "name": "Dipali Gan",
    "email": "gandipali4@gmail.com",
    "mobile": "7381766355",
    "block": "BASTA",
    "gp": "Barada",
    "photo": null,
    "social": {}
  },
  {
    "id": 173,
    "name": "Banita Aguan",
    "email": "aguanbanita@gmail.com",
    "mobile": "9583083196",
    "block": "BASTA",
    "gp": "Barada",
    "photo": null,
    "social": {}
  },
  {
    "id": 174,
    "name": "Saraswati Das",
    "email": "dasadwaita70@gmail.com",
    "mobile": "9438125737",
    "block": "BASTA",
    "gp": "Barada",
    "photo": null,
    "social": {}
  },
  {
    "id": 175,
    "name": "Rasmita Mohanty",
    "email": "mohantyrashmita2021@gmail.com",
    "mobile": "9777433457",
    "block": "BASTA",
    "gp": "Barada",
    "photo": null,
    "social": {}
  },
  {
    "id": 176,
    "name": "Kamala Hajira",
    "email": "kamlahajira1986@gmail.com",
    "mobile": "6371814472",
    "block": "BASTA",
    "gp": "Mathani",
    "photo": null,
    "social": {}
  },
  {
    "id": 177,
    "name": "Gitanjali Deuri",
    "email": "",
    "mobile": "9938255244",
    "block": "BASTA",
    "gp": "Gadapada",
    "photo": null,
    "social": {}
  },
  {
    "id": 178,
    "name": "Nayanika Nayak",
    "email": "",
    "mobile": "7855073014",
    "block": "BASTA",
    "gp": "Gadapada",
    "photo": null,
    "social": {}
  },
  {
    "id": 179,
    "name": "Sitamani Nayak",
    "email": "basantanayak097@gmail.com",
    "mobile": "8984159902",
    "block": "BASTA",
    "gp": "Gadapada",
    "photo": null,
    "social": {}
  },
  {
    "id": 180,
    "name": "Basumati Parida",
    "email": "basumatiparida335@gmai.com",
    "mobile": "9937878702",
    "block": "BASTA",
    "gp": "Dudhahansa",
    "photo": null,
    "social": {}
  },
  {
    "id": 181,
    "name": "Sanjulata Dalai",
    "email": "suryaprasaddalai484@gmail.com",
    "mobile": "7873757986",
    "block": "BASTA",
    "gp": "Tadada",
    "photo": null,
    "social": {}
  },
  {
    "id": 182,
    "name": "Ambika Jena",
    "email": "ambikajena39@gmail.com",
    "mobile": "9556922324",
    "block": "BASTA",
    "gp": "Karua",
    "photo": null,
    "social": {}
  },
  {
    "id": 183,
    "name": "Laxmipriya Patra",
    "email": "patrarajkisore78@gmail.com",
    "mobile": "7205602393",
    "block": "BASTA",
    "gp": "Karua",
    "photo": null,
    "social": {}
  },
  {
    "id": 184,
    "name": "Pramila Parta",
    "email": "patrapramila487@gmail.com",
    "mobile": "9937135663",
    "block": "BASTA",
    "gp": "Nikudi",
    "photo": null,
    "social": {}
  },
  {
    "id": 185,
    "name": "Rantamani Jena",
    "email": "jenaratnamani46@gmail.com",
    "mobile": "8018167225",
    "block": "BASTA",
    "gp": "Nikudi",
    "photo": null,
    "social": {}
  },
  {
    "id": 186,
    "name": "Laxmipriya Gantayat",
    "email": "laximipriyamanna574@gmail.com",
    "mobile": "7854898481",
    "block": "BASTA",
    "gp": "Putura",
    "photo": null,
    "social": {}
  },
  {
    "id": 187,
    "name": "Chumuki Patara",
    "email": "barsapatra123bls@gmail.com",
    "mobile": "7381168318",
    "block": "BASTA",
    "gp": "Nabara",
    "photo": null,
    "social": {}
  },
  {
    "id": 188,
    "name": "Sandhayrani Mohanty",
    "email": "chandrakantamohanty330@gmail.com",
    "mobile": "6372082402",
    "block": "BASTA",
    "gp": "Nabara",
    "photo": null,
    "social": {}
  },
  {
    "id": 189,
    "name": "Monarama Sethi",
    "email": "kusethibasanta@gmail.com",
    "mobile": "8018199321",
    "block": "BASTA",
    "gp": "Nabara",
    "photo": null,
    "social": {}
  },
  {
    "id": 190,
    "name": "Ranjita Rana",
    "email": "ranjitarana7938@gmail.com",
    "mobile": "9306736018",
    "block": "BASTA",
    "gp": "Basuchakuri",
    "photo": null,
    "social": {}
  },
  {
    "id": 191,
    "name": "Puspalata Jena",
    "email": "jenapuspa90@gmail.com",
    "mobile": "8917648699",
    "block": "BASTA",
    "gp": "Churmara",
    "photo": null,
    "social": {}
  },
  {
    "id": 192,
    "name": "Apalata Tripathy",
    "email": "sudamchandratripathy888@gmail.com",
    "mobile": "7894333241",
    "block": "BASTA",
    "gp": "Mukulisi",
    "photo": null,
    "social": {}
  },
  {
    "id": 193,
    "name": "Surekha Giri",
    "email": "",
    "mobile": "8984676180",
    "block": "BASTA",
    "gp": "Singla",
    "photo": null,
    "social": {}
  },
  {
    "id": 194,
    "name": "SUSMITA BARIK",
    "email": "susmitabarik75@gmail.com",
    "mobile": "9178148800",
    "block": "BHOGRAI",
    "gp": "SIANRAI",
    "photo": null,
    "social": {}
  },
  {
    "id": 195,
    "name": "SABITRI MANDAL",
    "email": "sabitrimandal.cns@gmail.com",
    "mobile": "6371316862",
    "block": "BHOGRAI",
    "gp": "BAJITPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 196,
    "name": "ANJANA JENA",
    "email": "",
    "mobile": "9777275127",
    "block": "BHOGRAI",
    "gp": "KUMBHARMULI",
    "photo": null,
    "social": {}
  },
  {
    "id": 197,
    "name": "SWARNALATA GIRI ",
    "email": "swrnalatagiri1@gmail.com",
    "mobile": "9777881374",
    "block": "BHOGRAI",
    "gp": "TUKURIHAZIRA",
    "photo": null,
    "social": {}
  },
  {
    "id": 198,
    "name": "LAXMIPRIYA  DAS",
    "email": "daslaxmipriya395@gmail.com",
    "mobile": "6370556742",
    "block": "BHOGRAI",
    "gp": "GUNAIBASAN",
    "photo": null,
    "social": {}
  },
  {
    "id": 199,
    "name": "SUBHADRA JENA",
    "email": "subhadraj408@gmail.com",
    "mobile": "6370871985",
    "block": "BHOGRAI",
    "gp": "SULTANPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 200,
    "name": "GOURI RANI PANDA",
    "email": "vrpgouri@gmail.com",
    "mobile": "7377624295",
    "block": "BHOGRAI",
    "gp": "JAGANNATHPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 201,
    "name": "MAMATA RANI JENA",
    "email": "mamatajena4000@gmail.com",
    "mobile": "9583733520",
    "block": "BHOGRAI",
    "gp": "NIMATPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 202,
    "name": "SHANTILATA JENA",
    "email": "jenaj8662@gmail.com",
    "mobile": "9556764214",
    "block": "BHOGRAI",
    "gp": "DEULA",
    "photo": null,
    "social": {}
  },
  {
    "id": 203,
    "name": "GIRIBALA  GIRI",
    "email": "giriraju3513@gmail.com",
    "mobile": "9337399416",
    "block": "BHOGRAI",
    "gp": "MONDARSAHI ",
    "photo": null,
    "social": {}
  },
  {
    "id": 204,
    "name": "PURNIMA DAS",
    "email": "debidas8018@gmail.com",
    "mobile": "6371667988",
    "block": "BHOGRAI",
    "gp": "JALESWARPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 205,
    "name": "SHAKUNTALA MOHANTY",
    "email": "shakuntalamohanty1122@gmail.com",
    "mobile": "7377700255",
    "block": "BHOGRAI",
    "gp": "KANTHIBHAUNRI",
    "photo": null,
    "social": {}
  },
  {
    "id": 206,
    "name": "BASUMATI SAHOO",
    "email": "basumatis81@gmail.com",
    "mobile": "9556412371",
    "block": "BHOGRAI",
    "gp": "NACHINDA",
    "photo": null,
    "social": {}
  },
  {
    "id": 207,
    "name": "SNEHALATA GIRI",
    "email": "",
    "mobile": "6372282424",
    "block": "BHOGRAI",
    "gp": "SUHORIA",
    "photo": null,
    "social": {}
  },
  {
    "id": 208,
    "name": "SWARNAMALI GIRI",
    "email": "giriswarnamali@gmaile.com",
    "mobile": "9337842713",
    "block": "BHOGRAI",
    "gp": "NIMATPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 209,
    "name": "JHARANARANI DAS",
    "email": "ccreative515@gmail.com",
    "mobile": "9776909871",
    "block": "BHOGRAI",
    "gp": " DEULA",
    "photo": null,
    "social": {}
  },
  {
    "id": 210,
    "name": "MADHURI MIRDHA",
    "email": "madhurimirdha5@gmailcom",
    "mobile": "9777382272",
    "block": "BHOGRAI",
    "gp": "PUTINA",
    "photo": null,
    "social": {}
  },
  {
    "id": 211,
    "name": "MOUMITA AICH",
    "email": "aichmoumita137@gmail.com",
    "mobile": "8984617818",
    "block": "BHOGRAI",
    "gp": "BAUNSADIHA",
    "photo": null,
    "social": {}
  },
  {
    "id": 212,
    "name": "SASMITA RANI GIRI",
    "email": "girisusmitarani@gmail.com",
    "mobile": "9390774891",
    "block": "BHOGRAI",
    "gp": "KUSUDA",
    "photo": null,
    "social": {}
  },
  {
    "id": 213,
    "name": "RADHA RANI PRADHAN",
    "email": "radhapradhan595@gmail.com",
    "mobile": "6372626233",
    "block": "BHOGRAI",
    "gp": "MAHESH PUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 214,
    "name": "SABITA GIRI",
    "email": "sabitagiri7260@gmail.com",
    "mobile": "9776351867",
    "block": "BHOGRAI",
    "gp": "KHARIDPIPAL",
    "photo": null,
    "social": {}
  },
  {
    "id": 215,
    "name": "KABITA RANI GHADAI",
    "email": "",
    "mobile": "8018052585",
    "block": "BHOGRAI",
    "gp": "PASORABINDA    ",
    "photo": null,
    "social": {}
  },
  {
    "id": 216,
    "name": "SASMITA SETHI",
    "email": "sasmitasethi247@gmail.com",
    "mobile": "7077679229",
    "block": "BHOGRAI",
    "gp": "BHOGRAI",
    "photo": null,
    "social": {}
  },
  {
    "id": 217,
    "name": "MAMTA DEY",
    "email": "mamata32@gmail.com",
    "mobile": "6372198156",
    "block": "BHOGRAI",
    "gp": "ARUHABRUTTI  NO1",
    "photo": null,
    "social": {}
  },
  {
    "id": 218,
    "name": "MANJUSHREE MOHANTY",
    "email": "manjushreemohanty17@gmail.com",
    "mobile": "6370733739",
    "block": "BHOGRAI",
    "gp": "KAKHARA",
    "photo": null,
    "social": {}
  },
  {
    "id": 219,
    "name": "NAMITA BEHERA",
    "email": "",
    "mobile": "8456065668",
    "block": "BHOGRAI",
    "gp": "TUKURIHAZIRA",
    "photo": null,
    "social": {}
  },
  {
    "id": 220,
    "name": "BHARATI SAHOO",
    "email": "sahoobharati1122@gmail.com",
    "mobile": "7606873100",
    "block": "BHOGRAI",
    "gp": "G. TEGHARI",
    "photo": null,
    "social": {}
  },
  {
    "id": 221,
    "name": "BHABANI DAS",
    "email": "",
    "mobile": "6372243884",
    "block": "BHOGRAI",
    "gp": "DARUHA",
    "photo": null,
    "social": {}
  },
  {
    "id": 222,
    "name": "BINAPANI PATRA",
    "email": "patrabinapani59@gmail.com",
    "mobile": "8144774297",
    "block": "BHOGRAI",
    "gp": "BHOGRAI",
    "photo": null,
    "social": {}
  },
  {
    "id": 223,
    "name": "BANDANA  DEY",
    "email": "deybandana17@gmail.com",
    "mobile": "6371015107",
    "block": "BHOGRAI",
    "gp": "GABAGAN",
    "photo": null,
    "social": {}
  },
  {
    "id": 224,
    "name": "SWARNALATA PANDA",
    "email": "swarnalatapanda74@gmail.com",
    "mobile": "8457895348",
    "block": "BHOGRAI",
    "gp": "NAHARA",
    "photo": null,
    "social": {}
  },
  {
    "id": 225,
    "name": "ITISHRE PATRA",
    "email": "itishrejayanta12@gmail.com",
    "mobile": "9583423173",
    "block": "BHOGRAI",
    "gp": "PANISANDA",
    "photo": null,
    "social": {}
  },
  {
    "id": 226,
    "name": "NAMITA MOHANTY",
    "email": "",
    "mobile": "8114330559",
    "block": "BHOGRAI",
    "gp": "KULIDA",
    "photo": null,
    "social": {}
  },
  {
    "id": 227,
    "name": "SUSAMA MOHANTY",
    "email": "susamamohanty727@gmail.com",
    "mobile": "8598907093",
    "block": "BHOGRAI",
    "gp": "MAHESHPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 228,
    "name": "JAPANI BEHERA",
    "email": "tapankumarbeherajapani@gmail.com",
    "mobile": "9937538740",
    "block": "BHOGRAI",
    "gp": "KAKHARA",
    "photo": null,
    "social": {}
  },
  {
    "id": 229,
    "name": "RASHMI PATRA",
    "email": "rashmipatra610@gmail.com",
    "mobile": "8117048839",
    "block": "BHOGRAI",
    "gp": "KANTHIBHAUNRI  ",
    "photo": null,
    "social": {}
  },
  {
    "id": 230,
    "name": "TAPOYEE JENA",
    "email": "tapoyeej@gmail.com",
    "mobile": "8455897092",
    "block": "BHOGRAI",
    "gp": "KHARIDPIPAL",
    "photo": null,
    "social": {}
  },
  {
    "id": 231,
    "name": "TILOTTAMA NAYAK",
    "email": "pintun920@gmail.com.in",
    "mobile": "7077257205",
    "block": "BHOGRAI",
    "gp": "KUMBHIRGADI",
    "photo": null,
    "social": {}
  },
  {
    "id": 232,
    "name": "AMITA PATRA",
    "email": "amitapatra368@gmail.com",
    "mobile": "6372179512",
    "block": "BHOGRAI",
    "gp": "PUTINA",
    "photo": null,
    "social": {}
  },
  {
    "id": 233,
    "name": "ARATI KUNDU",
    "email": "aratikundu7773@gmail.com",
    "mobile": "9348547773",
    "block": "BHOGRAI",
    "gp": "JALSOHARIA",
    "photo": null,
    "social": {}
  },
  {
    "id": 234,
    "name": "UMARANI SAMAL",
    "email": "dipa9842@gmail.com",
    "mobile": "7873638369",
    "block": "BHOGRAI",
    "gp": "MAHAGAB",
    "photo": null,
    "social": {}
  },
  {
    "id": 235,
    "name": "MANJU LATA DUTTA",
    "email": "janmejaydutta157@gmail.com",
    "mobile": "6370908712",
    "block": "BHOGRAI",
    "gp": "KACHUADI",
    "photo": null,
    "social": {}
  },
  {
    "id": 236,
    "name": "SUJATA KAR",
    "email": "arunkar9040@gmail.com",
    "mobile": "9040167441",
    "block": "BHOGRAI",
    "gp": "RASALPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 237,
    "name": "SANDHYA RANI SINGH",
    "email": "",
    "mobile": "6370676330",
    "block": "BHOGRAI",
    "gp": "BALIM",
    "photo": null,
    "social": {}
  },
  {
    "id": 238,
    "name": "SANJUKTA JENA",
    "email": "sanjuktajena637@gmail.com",
    "mobile": "6371571418",
    "block": "BHOGRAI",
    "gp": "GUNSARTHA",
    "photo": null,
    "social": {}
  },
  {
    "id": 239,
    "name": "PANKAJINEE BEHERA",
    "email": "pankajineebehera2017@gmail.com",
    "mobile": "6371113287",
    "block": "BHOGRAI",
    "gp": "GOCHHIDA TEGHORI",
    "photo": null,
    "social": {}
  },
  {
    "id": 240,
    "name": "JINA JAGRUTI DAS",
    "email": "dasjinajagruti6852@gmail.com",
    "mobile": "6371266852",
    "block": "BHOGRAI",
    "gp": "DUDPAL",
    "photo": null,
    "social": {}
  },
  {
    "id": 241,
    "name": "Santilata Jena ",
    "email": "santilatajena16@gmail.com",
    "mobile": "6371574159",
    "block": "JALESWAR ",
    "gp": "Khuard ",
    "photo": null,
    "social": {}
  },
  {
    "id": 242,
    "name": "Niharika patra ",
    "email": "duttadebashis427@gmail.com",
    "mobile": "9337924052",
    "block": "JALESWAR ",
    "gp": "shikharpur",
    "photo": null,
    "social": {}
  },
  {
    "id": 243,
    "name": "Runu Jena",
    "email": "runujena898@gmail.com",
    "mobile": "8339086979",
    "block": "JALESWAR ",
    "gp": "D.P.Pur",
    "photo": null,
    "social": {}
  },
  {
    "id": 244,
    "name": "Madhusmita Das",
    "email": "keshab ch.das413@gmail.com",
    "mobile": "6370295160",
    "block": "JALESWAR ",
    "gp": "Olmara",
    "photo": null,
    "social": {}
  },
  {
    "id": 245,
    "name": "Sukanti Das",
    "email": "sukanti@gmail.com",
    "mobile": "9124058404",
    "block": "JALESWAR ",
    "gp": "Baradiha",
    "photo": null,
    "social": {}
  },
  {
    "id": 246,
    "name": "Pratima Jena",
    "email": "pratimajena1983@gmail.com",
    "mobile": "6370769174",
    "block": "JALESWAR ",
    "gp": "Sugo",
    "photo": null,
    "social": {}
  },
  {
    "id": 247,
    "name": "Madhusmita Bhuyan",
    "email": "bhuyanmadusmita046@gmail.com",
    "mobile": "7682891572",
    "block": "JALESWAR ",
    "gp": "K.M.Sahi",
    "photo": null,
    "social": {}
  },
  {
    "id": 248,
    "name": "Binapani Sahoo",
    "email": "sahoobanapani38@gmail.com",
    "mobile": "6370621107",
    "block": "JALESWAR ",
    "gp": "Kotsahi",
    "photo": null,
    "social": {}
  },
  {
    "id": 249,
    "name": "Gitarani Dey",
    "email": "gitaranidey477@gmail.com",
    "mobile": "9827144581",
    "block": "JALESWAR ",
    "gp": "M.N.patna",
    "photo": null,
    "social": {}
  },
  {
    "id": 250,
    "name": "Umarani Singha",
    "email": "singhaumarani061@gmail.com",
    "mobile": "8342938247",
    "block": "JALESWAR ",
    "gp": "Nachhimpur ",
    "photo": null,
    "social": {}
  },
  {
    "id": 251,
    "name": "Jhunarani Parida",
    "email": "rabindra590@gmail.com",
    "mobile": "9668387844",
    "block": "JALESWAR ",
    "gp": "Kotsahi",
    "photo": null,
    "social": {}
  },
  {
    "id": 252,
    "name": "Santilata pattnayak ",
    "email": "sambunathpattnayak153@gmail.com",
    "mobile": "7873661791",
    "block": "JALESWAR ",
    "gp": "Kalika",
    "photo": null,
    "social": {}
  },
  {
    "id": 253,
    "name": "Debi Mahapatra ",
    "email": "debimahapatra67@gmail.com",
    "mobile": "7008195447",
    "block": "JALESWAR ",
    "gp": "Raibania",
    "photo": null,
    "social": {}
  },
  {
    "id": 254,
    "name": "Tulasi Ghosh",
    "email": "tulasighosh094@gmail.com",
    "mobile": "6371254202",
    "block": "JALESWAR ",
    "gp": "Raibania",
    "photo": null,
    "social": {}
  },
  {
    "id": 255,
    "name": "Usharani Mohanty",
    "email": "usharanimohanty183@gmail.com",
    "mobile": "9348245591",
    "block": "JALESWAR ",
    "gp": "Kalika",
    "photo": null,
    "social": {}
  },
  {
    "id": 256,
    "name": "Runubala Bhuyan",
    "email": "runubalabhuyan1000@gmail.com",
    "mobile": "9348097008",
    "block": "JALESWAR ",
    "gp": "Sugo",
    "photo": null,
    "social": {}
  },
  {
    "id": 257,
    "name": "Manjulata Dey",
    "email": "",
    "mobile": "7894145050",
    "block": "JALESWAR ",
    "gp": "Nampo",
    "photo": null,
    "social": {}
  },
  {
    "id": 258,
    "name": "Supriya Nandi",
    "email": "nandisupriya1990@gmail.com",
    "mobile": "8917361065",
    "block": "JALESWAR ",
    "gp": "R.R.pur",
    "photo": null,
    "social": {}
  },
  {
    "id": 259,
    "name": "Binata Das",
    "email": "binatad562@gmail.com",
    "mobile": "7682968779",
    "block": "JALESWAR ",
    "gp": "Jhadpimpal",
    "photo": null,
    "social": {}
  },
  {
    "id": 260,
    "name": "Smitarani Das",
    "email": "dassmitarani2040@gmail.com",
    "mobile": "9938113039",
    "block": "JALESWAR ",
    "gp": "Paikasida",
    "photo": null,
    "social": {}
  },
  {
    "id": 261,
    "name": "Lilima Pradhan ",
    "email": "nandagopal 5653@gmail.com",
    "mobile": "6370493833",
    "block": "JALESWAR ",
    "gp": "Samptia",
    "photo": null,
    "social": {}
  },
  {
    "id": 262,
    "name": "Subhadra Patra",
    "email": "patrasubhadra1234@gmail",
    "mobile": "9337116497",
    "block": "JALESWAR ",
    "gp": "Khalina",
    "photo": null,
    "social": {}
  },
  {
    "id": 263,
    "name": "Santilata Giri",
    "email": "girisantilata320@gmail.com",
    "mobile": "7894389616",
    "block": "JALESWAR ",
    "gp": "Gadasahi  BALIAPAL",
    "photo": null,
    "social": {}
  },
  {
    "id": 264,
    "name": "Mamata Mallik",
    "email": "kb8304441@gmail.com",
    "mobile": "8594826211",
    "block": "JALESWAR ",
    "gp": "srirampur ",
    "photo": null,
    "social": {}
  },
  {
    "id": 265,
    "name": "Sabita Das",
    "email": "sd1315577@gmail.com",
    "mobile": "7735051942",
    "block": "JALESWAR ",
    "gp": "K.M.Sahi",
    "photo": null,
    "social": {}
  },
  {
    "id": 266,
    "name": "Subhashree Das",
    "email": "subhashree179@gmail.com",
    "mobile": "7978734332",
    "block": "JALESWAR ",
    "gp": "Olmara",
    "photo": null,
    "social": {}
  },
  {
    "id": 267,
    "name": "Kabita Dalai",
    "email": "kdalai922@gmail.com",
    "mobile": "9337828196",
    "block": "JALESWAR ",
    "gp": "Gobaraghata",
    "photo": null,
    "social": {}
  },
  {
    "id": 268,
    "name": "sulachana Mohapatra ",
    "email": "sulachanamohapatra22@gmail.com",
    "mobile": "6372232298",
    "block": "JALESWAR ",
    "gp": "Aruha",
    "photo": null,
    "social": {}
  },
  {
    "id": 269,
    "name": "Padmabati Pal",
    "email": "padmabatipal508@gmail.com",
    "mobile": "9668628220",
    "block": "JALESWAR ",
    "gp": "Aruha",
    "photo": null,
    "social": {}
  },
  {
    "id": 270,
    "name": "Prabhati Mahanta",
    "email": "paravatimahanta15@gmail.com",
    "mobile": "7894708047",
    "block": "JALESWAR ",
    "gp": "Shyamnagar ",
    "photo": null,
    "social": {}
  },
  {
    "id": 271,
    "name": "Kanaka lata Gandhi",
    "email": "kanakalatagandhi@gmail.com",
    "mobile": "9583888063",
    "block": "JALESWAR ",
    "gp": "Raibania",
    "photo": null,
    "social": {}
  },
  {
    "id": 272,
    "name": "puspanjali Dandapat ",
    "email": "puspanjalidandpat0@gmail.com",
    "mobile": "6371384067",
    "block": "JALESWAR ",
    "gp": "Paschimbad",
    "photo": null,
    "social": {}
  },
  {
    "id": 273,
    "name": "Gitarani Giri",
    "email": "bijaykumargiri9483@gmail.com",
    "mobile": "8984494019",
    "block": "JALESWAR ",
    "gp": "Baiganbadia",
    "photo": null,
    "social": {}
  },
  {
    "id": 274,
    "name": "sabita Hui",
    "email": "sabitahui1980@gmail.com",
    "mobile": "9238965899",
    "block": "JALESWAR ",
    "gp": "Nampo",
    "photo": null,
    "social": {}
  },
  {
    "id": 275,
    "name": "Mamata  Rani Pradhan",
    "email": "pradhanmamata837@gmail.com",
    "mobile": "",
    "block": "JALESWAR ",
    "gp": "Makidia",
    "photo": null,
    "social": {}
  },
  {
    "id": 276,
    "name": " Jyotsnamayee Poi ",
    "email": "harekrushnas984@gmail.com",
    "mobile": "9938556630",
    "block": "OUPADA ",
    "gp": "fatepur",
    "photo": null,
    "social": {}
  },
  {
    "id": 277,
    "name": "PRITILATA SAMAL",
    "email": "",
    "mobile": "8260681530",
    "block": "OUPADA ",
    "gp": "ISWARPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 278,
    "name": "MAMATA RANI ROUT",
    "email": "",
    "mobile": "8018223914",
    "block": "OUPADA ",
    "gp": "KANDAGARADI",
    "photo": null,
    "social": {}
  },
  {
    "id": 279,
    "name": "DHIRAMANI MOHANTY",
    "email": "",
    "mobile": "9348644965",
    "block": "OUPADA ",
    "gp": "BAUNSABANIA",
    "photo": null,
    "social": {}
  },
  {
    "id": 280,
    "name": "KALYANI BEHERA ",
    "email": "",
    "mobile": "7653832677",
    "block": "OUPADA ",
    "gp": "RAIRAMCHANDRAPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 281,
    "name": "NIRUPAMA BEHERA",
    "email": "nirupamabehera993@gmail.com",
    "mobile": "6372004140",
    "block": "OUPADA ",
    "gp": "AGHIRAPADA",
    "photo": null,
    "social": {}
  },
  {
    "id": 282,
    "name": "PADMINI BARIK",
    "email": "",
    "mobile": "7008987531",
    "block": "OUPADA ",
    "gp": "BADAPOKHARI",
    "photo": null,
    "social": {}
  },
  {
    "id": 283,
    "name": "SUSANTI JENA",
    "email": "",
    "mobile": "7894075864",
    "block": "OUPADA ",
    "gp": "SHYAMASUNDARPUR",
    "photo": null,
    "social": {}
  },
  {
    "id": 284,
    "name": "Subhalaxmi Tapaswi",
    "email": "tapaswisubhalaxmi@gmail.com",
    "mobile": "7684836962",
    "block": "Sadar",
    "gp": "Odangi",
    "photo": null,
    "social": {}
  },
  {
    "id": 285,
    "name": "Sasmita Nayak",
    "email": "sn6236564@gmail.com",
    "mobile": "7873430047",
    "block": "Sadar",
    "gp": "Chhanua",
    "photo": null,
    "social": {}
  },
  {
    "id": 286,
    "name": "Subhashree Dash",
    "email": "subhashreedas@gmail.com",
    "mobile": "8249699513",
    "block": "Sadar",
    "gp": "Padampur",
    "photo": null,
    "social": {}
  },
  {
    "id": 287,
    "name": "Sumitra Pradhan",
    "email": "sumitrapradhan9937@gmail.com",
    "mobile": "8018446602",
    "block": "Sadar",
    "gp": "Chhanua",
    "photo": null,
    "social": {}
  },
  {
    "id": 288,
    "name": "Jayashree Biswal",
    "email": "",
    "mobile": "7077932885",
    "block": "Sadar",
    "gp": "Dublagadi",
    "photo": null,
    "social": {}
  },
  {
    "id": 289,
    "name": "Rajashree Jena",
    "email": "",
    "mobile": "9439911537",
    "block": "Sadar",
    "gp": "Rasalpur",
    "photo": null,
    "social": {}
  },
  {
    "id": 290,
    "name": "Rajashree Ghadei",
    "email": "rajashreeghadei85@gmail.com",
    "mobile": "8763600078",
    "block": "Sadar",
    "gp": "Anko",
    "photo": null,
    "social": {}
  },
  {
    "id": 291,
    "name": "Laxmimani  Behera",
    "email": "",
    "mobile": "7381607961",
    "block": "Sadar",
    "gp": "Chhanua",
    "photo": null,
    "social": {}
  },
  {
    "id": 292,
    "name": "Malati Barik",
    "email": "malatibarik96@gmail.com",
    "mobile": "9861198625",
    "block": "Sadar",
    "gp": "Chhanua",
    "photo": null,
    "social": {}
  },
  {
    "id": 293,
    "name": "Babita Khatua",
    "email": "babitakhatua6@gmail.com",
    "mobile": "9583279812",
    "block": "Sadar",
    "gp": "Kasafal",
    "photo": null,
    "social": {}
  },
  {
    "id": 294,
    "name": "Mamata Giri",
    "email": "mamatagiri822@gmail.com",
    "mobile": "9337708551",
    "block": "Sadar",
    "gp": "Kasipada",
    "photo": null,
    "social": {}
  },
  {
    "id": 295,
    "name": "Bhanumati Behera",
    "email": "bhanumatibehera729@gmail.com",
    "mobile": "9583532824",
    "block": "Sadar",
    "gp": "Kasipada",
    "photo": null,
    "social": {}
  },
  {
    "id": 296,
    "name": "Mamata Mohapatra",
    "email": "mohapatramamata5734@gmail.com",
    "mobile": "9178623177",
    "block": "Sadar",
    "gp": "Sindhia",
    "photo": null,
    "social": {}
  },
  {
    "id": 297,
    "name": "Gitanjali Giri",
    "email": "gitanjalig@gmail.com",
    "mobile": "8249162643",
    "block": "Sadar",
    "gp": "Anko",
    "photo": null,
    "social": {}
  },
  {
    "id": 298,
    "name": "Solochana Acharya",
    "email": "acharyasulochana682@gmail.com",
    "mobile": "8260012750",
    "block": "Sadar",
    "gp": "Genguti",
    "photo": null,
    "social": {}
  },
  {
    "id": 299,
    "name": "Gouri Das",
    "email": "",
    "mobile": "9437410766",
    "block": "Sadar",
    "gp": "Nagram",
    "photo": null,
    "social": {}
  },
  {
    "id": 300,
    "name": "Dipika Behera",
    "email": "beheradeepika14@gmail.com",
    "mobile": "7609022891",
    "block": "Sadar",
    "gp": "Shirampur",
    "photo": null,
    "social": {}
  },
  {
    "id": 301,
    "name": "Padmini Behera",
    "email": "dasmami088@gmail.com",
    "mobile": "7978153829",
    "block": "Sadar",
    "gp": "Patrapada",
    "photo": null,
    "social": {}
  },
  {
    "id": 302,
    "name": "Sitamani Jena",
    "email": "sitamanijena05@gmail.com",
    "mobile": "9777371316",
    "block": "Sadar",
    "gp": "Nagram",
    "photo": null,
    "social": {}
  },
  {
    "id": 303,
    "name": "Srimati Jena",
    "email": "sjena86102@gmail.com",
    "mobile": "9937091898",
    "block": "Sadar",
    "gp": "Buanl",
    "photo": null,
    "social": {}
  },
  {
    "id": 304,
    "name": "Bismita Bhuyan",
    "email": "bhyanbismita50@gmail.com",
    "mobile": "8594917301",
    "block": "Sadar",
    "gp": "O.Sargan",
    "photo": null,
    "social": {}
  },
  {
    "id": 305,
    "name": "Jayanti Ganda",
    "email": "",
    "mobile": "8908032950",
    "block": "Sadar",
    "gp": "O.Sargan",
    "photo": null,
    "social": {}
  },
  {
    "id": 306,
    "name": "Dali Mohapatra",
    "email": "dalipradhan575@gmail.com",
    "mobile": "7853840319",
    "block": "Sadar",
    "gp": "Srirampur",
    "photo": null,
    "social": {}
  },
  {
    "id": 307,
    "name": "Basanti Rout",
    "email": "routbasanti708@gmail.com",
    "mobile": "7608900470",
    "block": "Sadar",
    "gp": "OlandaSargan",
    "photo": null,
    "social": {}
  },
  {
    "id": 308,
    "name": "Losita Panda",
    "email": "lusitapanda76@gmail.com",
    "mobile": "8637293138",
    "block": "Sadar",
    "gp": "Gudu",
    "photo": null,
    "social": {}
  },
  {
    "id": 309,
    "name": "Dharitri Mohanty",
    "email": "daritribls@gmail.com",
    "mobile": "9337383772",
    "block": "Sadar",
    "gp": "Patrapada",
    "photo": null,
    "social": {}
  },
  {
    "id": 310,
    "name": "Sanjita Jena",
    "email": "",
    "mobile": "7684838180",
    "block": "Sadar",
    "gp": "Rasalpur",
    "photo": null,
    "social": {}
  },
  {
    "id": 311,
    "name": "Mayabati Jena",
    "email": "mayabatijena73@gmail.com",
    "mobile": "9938353172",
    "block": "Sadar",
    "gp": "Ranasahi",
    "photo": null,
    "social": {}
  },
  {
    "id": 312,
    "name": "Harapriya Rout",
    "email": "routharapriya072@gmail.com",
    "mobile": "7437024813",
    "block": "Sadar",
    "gp": "Odaangi",
    "photo": null,
    "social": {}
  },
  {
    "id": 313,
    "name": "Snehalata Das",
    "email": "snehalatad508@gmail.com",
    "mobile": "6372589016",
    "block": "Sadar",
    "gp": "Raisuan",
    "photo": null,
    "social": {}
  },
  {
    "id": 314,
    "name": "Ranjita Das",
    "email": "dasranjita643@gmail.com",
    "mobile": "7894522910",
    "block": "Sadar",
    "gp": "Raisuan",
    "photo": null,
    "social": {}
  },
  {
    "id": 315,
    "name": "Madhusmita Barik",
    "email": "madhusmitabarik570@gmail.com",
    "mobile": "7064103110",
    "block": "Sadar",
    "gp": "Anko",
    "photo": null,
    "social": {}
  },
  {
    "id": 316,
    "name": "Damayanti Pradhan",
    "email": "damayantipradhan70775@gmail.com",
    "mobile": "8984953891",
    "block": "Sadar",
    "gp": "Baincha",
    "photo": null,
    "social": {}
  },
  {
    "id": 317,
    "name": "Sonali Mohanty",
    "email": "sonalimohanty836@gmail.com",
    "mobile": "7847002117",
    "block": "Sadar",
    "gp": "Rasulpur",
    "photo": null,
    "social": {}
  },
  {
    "id": 318,
    "name": "Anusaya Barik",
    "email": "anusayabarik80@gmail.com",
    "mobile": "7077933026",
    "block": "Sadar",
    "gp": "Olanda Sargan",
    "photo": null,
    "social": {}
  },
  {
    "id": 319,
    "name": "Rashmi Das",
    "email": "rashmidas721@gmail.com",
    "mobile": "6372190974",
    "block": "Sadar",
    "gp": "Olanda Sargan",
    "photo": null,
    "social": {}
  },
  {
    "id": 320,
    "name": "Rebati Mishra",
    "email": "",
    "mobile": "7735253603",
    "block": "Sadar",
    "gp": "Hidigan",
    "photo": null,
    "social": {}
  },
  {
    "id": 321,
    "name": "Sasmita Nayak",
    "email": "sn029760@gmail.com",
    "mobile": "8260103759",
    "block": "Sadar",
    "gp": "Sartha",
    "photo": null,
    "social": {}
  },
  {
    "id": 322,
    "name": "Bijayalaxmi Jena",
    "email": "jenabijayalaxmi3@gmail.com",
    "mobile": "8260528792",
    "block": "Sadar",
    "gp": "Sartha",
    "photo": null,
    "social": {}
  },
  {
    "id": 323,
    "name": "Pramita Das",
    "email": "dpramita@gmail.com",
    "mobile": "9178144744",
    "block": "Sadar",
    "gp": "Rasalpur",
    "photo": null,
    "social": {}
  },
  {
    "id": 324,
    "name": "Snehalata Mohanty",
    "email": "mohantysnehalata189@gmail.com",
    "mobile": "6370990195",
    "block": "Sadar",
    "gp": "Kasafal",
    "photo": null,
    "social": {}
  },
  {
    "id": 325,
    "name": "Rina Rout",
    "email": "rinarout445@gmail.com",
    "mobile": "6371829052",
    "block": "Sadar",
    "gp": "Chhanua",
    "photo": null,
    "social": {}
  },
  {
    "id": 326,
    "name": "Brundabati Behera",
    "email": "brundabatib03@gmail.com",
    "mobile": "7854851107",
    "block": "Sadar",
    "gp": "Chhanua",
    "photo": null,
    "social": {}
  },
  {
    "id": 327,
    "name": "Satyabhama Nath",
    "email": "nathj6792@gmail.com",
    "mobile": "7894601510",
    "block": "Sadar",
    "gp": "Gopinathpur",
    "photo": null,
    "social": {}
  },
  {
    "id": 328,
    "name": "Simarani Biswal",
    "email": "simaranibswl@gmail.com",
    "mobile": "7978283351",
    "block": "Sadar",
    "gp": "Sindhia",
    "photo": null,
    "social": {}
  },
  {
    "id": 329,
    "name": "Nayana Das",
    "email": "nd6809770@gmail.com",
    "mobile": "8917268560",
    "block": "Sadar",
    "gp": "Gopinathpur",
    "photo": null,
    "social": {}
  },
  {
    "id": 330,
    "name": "Nidrabati Majhi",
    "email": "nidrabatimajhi679@gmail.com",
    "mobile": "9777266408",
    "block": "Sadar",
    "gp": "Patrapada",
    "photo": null,
    "social": {}
  },
  {
    "id": 331,
    "name": "Jharanarani Behera",
    "email": "jharanaranibehera43@gmail.com",
    "mobile": "6370170220",
    "block": "Sadar",
    "gp": "Rupsa samil hasanpur",
    "photo": null,
    "social": {}
  },
  {
    "id": 332,
    "name": "Manorama Chanda",
    "email": "monaramachanda@gmail.com",
    "mobile": "9583900583",
    "block": "Sadar",
    "gp": "Ranasahi",
    "photo": null,
    "social": {}
  },
  {
    "id": 333,
    "name": "Satyabhama Das",
    "email": "dassatyabhama56@gmail.com",
    "mobile": "9668297329",
    "block": "Sadar",
    "gp": "Gudu",
    "photo": null,
    "social": {}
  },
  {
    "id": 334,
    "name": "Kanchan Kuanr",
    "email": "",
    "mobile": "7008894705",
    "block": "Sadar",
    "gp": "Gudu",
    "photo": null,
    "social": {}
  },
  {
    "id": 335,
    "name": "Sumati Nayak",
    "email": "nayaksumati782@gmail.com",
    "mobile": "9853911451",
    "block": "Sadar",
    "gp": "Odangi",
    "photo": null,
    "social": {}
  },
  {
    "id": 336,
    "name": "Bhanumati Das",
    "email": "bhanumatidas812@gmail.com",
    "mobile": "9337395917",
    "block": "Sadar",
    "gp": "Sargan",
    "photo": null,
    "social": {}
  },
  {
    "id": 337,
    "name": "Sitamani Pradhan",
    "email": "sitamanipradhan468@gmail.com",
    "mobile": "7064160702",
    "block": "Sadar",
    "gp": "Srirampur",
    "photo": null,
    "social": {}
  },
  {
    "id": 338,
    "name": "Manini Nath",
    "email": "nathmanini94@gmail.com",
    "mobile": "7008312832",
    "block": "Sadar",
    "gp": "Hidigan",
    "photo": null,
    "social": {}
  },
  {
    "id": 339,
    "name": "Saraswati Sahu",
    "email": "saraswatisahu371@gmail.com",
    "mobile": "8114713593",
    "block": "Sadar",
    "gp": "Parikhi",
    "photo": null,
    "social": {}
  }

    ],
    other: [
      {
        id: 5,
        name: "SatyaNaranya Behera",
        email: "satyasocialaudit@gmail.com",
        mobile: "+91 9937420134",
        photo: null,
        social: {
          // facebook: "https://facebook.com/vikramsingh",
          // instagram: "https://instagram.com/vikramsingh"
        }
      }
    ]
  });

  // Filter states
// const [blockFilter, setBlockFilter] = useState('');
// const [gpFilter, setGpFilter] = useState('');
// const [searchQuery, setSearchQuery] = useState('');
// const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
// const [searchPerformed, setSearchPerformed] = useState(false);

// // Get unique blocks (sorted)
// const allBlocks = [...new Set([...people.blocksocialaudit, ...people.vrp].map(p => p.block).filter(Boolean))].sort();

// // Get GPs filtered by selected block (sorted)
// const filteredGPs = blockFilter 
//   ? [...new Set(people.vrp.filter(p => (p.block || "").toLowerCase() === blockFilter.toLowerCase()).map(p => p.gp).filter(Boolean))].sort()
//   : [...new Set(people.vrp.map(p => p.gp).filter(Boolean))].sort();

// // Filter function
// const filterPeople = (peopleList) => {
//   const query = searchQuery.toLowerCase();

//   return peopleList.filter(person => {
//     const matchesBlock = !blockFilter || (person.block || "").toLowerCase() === blockFilter.toLowerCase();
//     const matchesGP = !gpFilter || (person.gp || "").toLowerCase() === gpFilter.toLowerCase();

//     const matchesSearch =
//       !searchQuery ||
//       (person.name || "").toLowerCase().includes(query) ||
//       (person.email || "").toLowerCase().includes(query) ||
//       (person.block || "").toLowerCase().includes(query) ||
//       (person.gp || "").toLowerCase().includes(query) ||
//       (person.mobile || "").toLowerCase().includes(query);

//     return matchesBlock && matchesGP && matchesSearch;
//   });
// };

// // Filter "other" people (they don't have block/GP filters, only search)
// // Filter "other" people (they don't have block/GP filters, only search)
// const filterOtherPeople = (peopleList) => {
//   // If block or GP filter is active, don't show other personnel
//   if (blockFilter || gpFilter) {
//     return [];
//   }
  
//   return peopleList.filter(person => {
//     const matchesSearch = !searchQuery || 
//       person.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       person.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       (person.mobile && person.mobile.toLowerCase().includes(searchQuery.toLowerCase()));
    
//     return matchesSearch;
//   });
// };
// // Get total counts
// const getTotalCount = () => {
//   return filterPeople(people.blocksocialaudit).length + 
//          filterPeople(people.vrp).length + 
//          filterOtherPeople(people.other).length;
// };

// // Perform search
// const performSearch = () => {
//   setSearchPerformed(true);
//   // Scroll to results
//   setTimeout(() => {
//     const firstSection = document.getElementById('blocksocialaudit');
//     if (firstSection) {
//       firstSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     }
//   }, 100);
// };

// // Clear all filters
// const clearFilters = () => {
//   setBlockFilter('');
//   setGpFilter('');
//   setSearchQuery('');
//   setSearchPerformed(false);
// };

// const hasActiveFilters = blockFilter || gpFilter || searchQuery;
// const resultsCount = getTotalCount();

// useEffect(() => {
//   if (location.hash) {
//     const element = document.querySelector(location.hash);
//     if (element) {
//       element.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     }
//   }
// }, [location]);

// // Reset GP filter when block changes if current GP is not in the new block
// useEffect(() => {
//   if (blockFilter && gpFilter) {
//     const gpsInSelectedBlock = people.vrp
//       .filter(p => (p.block || "").toLowerCase() === blockFilter.toLowerCase())
//       .map(p => p.gp);
    
//     if (!gpsInSelectedBlock.some(gp => gp.toLowerCase() === gpFilter.toLowerCase())) {
//       setGpFilter('');
//     }
//   }
//   // eslint-disable-next-line react-hooks/exhaustive-deps
// }, [blockFilter]);
// Filter states
  const [blockFilter, setBlockFilter] = useState('');
  const [gpFilter, setGpFilter] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [searchPerformed, setSearchPerformed] = useState(false);

  // Normalize block names (trim spaces and uppercase)
  const normalizeBlock = (block) => {
    return (block || "").trim().toUpperCase();
  };

  // Get unique blocks (normalized and sorted)
  const allBlocks = [...new Set([
    ...people.blocksocialaudit.map(p => normalizeBlock(p.block)),
    ...people.vrp.map(p => normalizeBlock(p.block))
  ].filter(Boolean))].sort();

  // Get GPs filtered by selected block (normalized and sorted)
  const filteredGPs = blockFilter 
    ? [...new Set(
        people.vrp
          .filter(p => normalizeBlock(p.block) === blockFilter)
          .map(p => (p.gp || "").trim())
          .filter(Boolean)
      )].sort()
    : [...new Set(people.vrp.map(p => (p.gp || "").trim()).filter(Boolean))].sort();

  // Filter function
  const filterPeople = (peopleList) => {
    const query = searchQuery.toLowerCase();
    return peopleList.filter(person => {
      const matchesBlock = !blockFilter || normalizeBlock(person.block) === blockFilter;
      const matchesGP = !gpFilter || (person.gp || "").trim().toLowerCase() === gpFilter.toLowerCase();
      const matchesSearch = !searchQuery || 
        (person.name || "").toLowerCase().includes(query) ||
        (person.email || "").toLowerCase().includes(query) ||
        normalizeBlock(person.block).toLowerCase().includes(query) ||
        (person.gp || "").toLowerCase().includes(query) ||
        (person.mobile || "").toLowerCase().includes(query);
      
      return matchesBlock && matchesGP && matchesSearch;
    });
  };

  // Filter "other" people (they don't have block/GP filters, only search)
  const filterOtherPeople = (peopleList) => {
    if (blockFilter || gpFilter) {
      return [];
    }
    return peopleList.filter(person => {
      const matchesSearch = !searchQuery ||
        person.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        person.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (person.mobile && person.mobile.toLowerCase().includes(searchQuery.toLowerCase()));
      return matchesSearch;
    });
  };

  // NEW: Group VRP by Block and GP
  // const groupVRPByBlockAndGP = (vrpList) => {
  //   const grouped = {};
    
  //   vrpList.forEach(person => {
  //     const block = normalizeBlock(person.block);
  //     const gp = (person.gp || "").trim();
      
  //     if (!block) return;
      
  //     if (!grouped[block]) {
  //       grouped[block] = {};
  //     }
      
  //     if (!grouped[block][gp]) {
  //       grouped[block][gp] = [];
  //     }
      
  //     grouped[block][gp].push(person);
  //   });
    
  //   return grouped;
  // };

  // Get total counts
  const getTotalCount = () => {
    return filterPeople(people.blocksocialaudit).length +
           filterPeople(people.vrp).length +
           filterOtherPeople(people.other).length;
  };

  // Perform search
  const performSearch = () => {
    setSearchPerformed(true);
    setTimeout(() => {
      const firstSection = document.getElementById('blocksocialaudit');
      if (firstSection) {
        firstSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  // Clear all filters
  const clearFilters = () => {
    setBlockFilter('');
    setGpFilter('');
    setSearchQuery('');
    setSearchPerformed(false);
  };

  const hasActiveFilters = blockFilter || gpFilter || searchQuery;
  const resultsCount = getTotalCount();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [location]);

  // Reset GP filter when block changes if current GP is not in the new block
 // eslint-disable-next-line react-hooks/exhaustive-deps
useEffect(() => {
  if (blockFilter && gpFilter) {
    const gpsInSelectedBlock = people.vrp
      .filter(p => normalizeBlock(p.block) === blockFilter)
      .map(p => (p.gp || "").trim());
    if (!gpsInSelectedBlock.some(gp => gp.toLowerCase() === gpFilter.toLowerCase())) {
      setGpFilter('');
    }
  }
}, [blockFilter, gpFilter, people.vrp]); 
  const PersonCard = ({ person, showGP = false }) => (
    <div className="person-card">
      <div className="person-card-inner">
        {/* Photo or User Icon */}
        <div className="person-photo">
          {person.photo ? (
            <img 
              src={person.photo} 
              alt={person.name}
            />
          ) : (
            <div className="person-avatar">
              <User size={40} strokeWidth={1.5} />
            </div>
          )}
        </div>

        {/* Details */}
        <div className="person-details">
          <h3 className="person-name">{person.name}</h3>

          {/* Location */}
          {person.block && (
            <div className="person-location">
              <MapPin size={14} />
              <span>{person.block}</span>
            </div>
          )}
          {showGP && person.gp && (
            <div className="person-gp">{person.gp}</div>
          )}

          {/* Contact */}
          <div className="person-contact">
            <div className="contact-item">
              <Mail size={14} />
              <a href={`mailto:${person.email}`}>{person.email}</a>
            </div>
            <div className="contact-item">
              <Phone size={14} />
              <a href={`tel:${person.mobile}`}>{person.mobile}</a>
            </div>
          </div>

          {/* Social Media */}
          {person.social && (
            <div className="person-social">
              {person.social.facebook && (
                <a 
                  href={person.social.facebook} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link facebook"
                  title="Facebook"
                >
                  <Facebook size={16} />
                </a>
              )}
              {person.social.twitter && (
                <a 
                  href={person.social.twitter} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link twitter"
                  title="Twitter"
                >
                  <Twitter size={16} />
                </a>
              )}
              {person.social.linkedin && (
                <a 
                  href={person.social.linkedin} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link linkedin"
                  title="LinkedIn"
                >
                  <Linkedin size={16} />
                </a>
              )}
              {person.social.instagram && (
                <a 
                  href={person.social.instagram} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link instagram"
                  title="Instagram"
                >
                  <Instagram size={16} />
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Tiro+Devanagari+Hindi:ital@0;1&family=Source+Sans+3:wght@300;400;600;700&display=swap');

        :root {
          --gov-saffron: #FF9933;
          --gov-white: #FFFFFF;
          --gov-green: #138808;
          --gov-navy: #000080;
          --gov-blue: #1a73e8;
          --gov-text: #202124;
          --gov-text-secondary: #5f6368;
          --gov-border: #dadce0;
          --gov-bg: #f8f9fa;
          --gov-card-bg: #ffffff;
          --gov-shadow: 0 1px 2px 0 rgba(60,64,67,.3), 0 1px 3px 1px rgba(60,64,67,.15);
          --gov-shadow-hover: 0 1px 3px 0 rgba(60,64,67,.3), 0 4px 8px 3px rgba(60,64,67,.15);
        }

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: 'Source Sans 3', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: var(--gov-text);
          background-color: var(--gov-bg);
          line-height: 1.6;
        }

        .whos-who-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0;
        }

        /* Header Section */
        .page-header {
          background: linear-gradient(135deg, var(--gov-navy) 0%, #1a3a6b 100%);
          color: white;
          padding: 2rem 2rem 1.5rem;
          position: relative;
          overflow: hidden;
        }

        .page-header::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, var(--gov-saffron) 0%, var(--gov-saffron) 33.33%, var(--gov-white) 33.33%, var(--gov-white) 66.66%, var(--gov-green) 66.66%, var(--gov-green) 100%);
        }

        .page-header::after {
          content: '';
          position: absolute;
          top: 0;
          right: -100px;
          width: 300px;
          height: 300px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 50%;
          animation: floatShape 20s infinite ease-in-out;
        }

        @keyframes floatShape {
          0%, 100% { transform: translate(0, 0) rotate(0deg); }
          50% { transform: translate(-50px, 50px) rotate(180deg); }
        }

        .page-title {
          font-family: 'Tiro Devanagari Hindi', serif;
          font-size: 2rem;
          font-weight: 400;
          margin-bottom: 0.375rem;
          position: relative;
          z-index: 1;
          letter-spacing: 0.5px;
        }

        .page-subtitle {
          font-size: 0.95rem;
          opacity: 0.9;
          font-weight: 300;
          position: relative;
          z-index: 1;
        }

        .results-summary {
          margin-top: 1rem;
          padding: 0.75rem 1.25rem;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 6px;
          backdrop-filter: blur(10px);
          display: inline-block;
          font-size: 0.875rem;
        }

        .results-summary strong {
          font-size: 1.5rem;
          margin-right: 0.5rem;
          color: var(--gov-saffron);
        }

        /* Filter Section */
        .filter-section {
          padding: 1.25rem 1.5rem;
          background: var(--gov-card-bg);
          margin: -2rem 2rem 2rem;
          border-radius: 8px;
          box-shadow: var(--gov-shadow);
          position: relative;
          z-index: 10;
        }

        .filter-header {
          margin-bottom: 1rem;
        }

        .filter-title {
          font-size: 0.875rem;
          font-weight: 600;
          color: var(--gov-text-secondary);
          display: flex;
          align-items: center;
          gap: 0.375rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .filter-toggle {
          display: none;
        }

        .search-bar-wrapper {
          position: relative;
        }

        .search-bar-container {
          display: flex;
          gap: 0.625rem;
          align-items: stretch;
        }

        .search-input-wrapper {
          position: relative;
          flex: 1;
        }

        .search-icon-left {
          position: absolute;
          left: 0.75rem;
          top: 50%;
          transform: translateY(-50%);
          color: var(--gov-text-secondary);
          pointer-events: none;
        }

        .filter-input {
          width: 100%;
          padding: 0.625rem 2.25rem 0.625rem 2.5rem;
          border: 1px solid var(--gov-border);
          border-radius: 6px;
          font-size: 0.875rem;
          font-family: inherit;
          transition: all 0.2s ease;
          background: white;
        }

        .filter-input:focus {
          outline: none;
          border-color: var(--gov-blue);
          box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.08);
        }

      .clear-search-btn {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: var(--gov-text-secondary);
  cursor: pointer;
  padding: 0.125rem;
  border-radius: 3px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
}

        .clear-search-btn:hover {
          background: var(--gov-bg);
          color: var(--gov-text);
        }

        .search-btn {
          padding: 0.625rem 1.25rem;
          background: var(--gov-blue);
          color: white;
          border: none;
          border-radius: 6px;
          font-weight: 600;
          font-size: 0.875rem;
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          gap: 0.375rem;
          white-space: nowrap;
        }

        .search-btn:hover {
          background: var(--gov-navy);
          transform: translateY(-1px);
        }

        .search-btn:active {
          transform: translateY(0);
        }

        /* Search Status */
        .search-status {
          margin-top: 0.875rem;
          padding: 0.75rem 1rem;
          background: linear-gradient(135deg, #f0f7ff 0%, #e3f2fd 100%);
          border-left: 3px solid var(--gov-blue);
          border-radius: 6px;
          display: flex;
          align-items: center;
          gap: 0.625rem;
          animation: slideDown 0.3s ease;
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .search-status.success {
          background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
          border-left-color: #16a34a;
        }

        .search-status.warning {
          background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
          border-left-color: #f59e0b;
        }

        .search-status-icon {
          flex-shrink: 0;
          width: 32px;
          height: 32px;
          background: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }

        .search-status.success .search-status-icon {
          color: #16a34a;
        }

        .search-status.warning .search-status-icon {
          color: #f59e0b;
        }

        .search-status-content {
          flex: 1;
        }

        .search-status-title {
          font-weight: 600;
          font-size: 0.8125rem;
          color: var(--gov-text);
          margin-bottom: 0.125rem;
        }

        .search-status-text {
          font-size: 0.8125rem;
          color: var(--gov-text-secondary);
          line-height: 1.4;
        }

        .search-status-count {
          font-weight: 700;
          color: var(--gov-blue);
        }

        .search-status.success .search-status-count {
          color: #16a34a;
        }

        .search-status.warning .search-status-count {
          color: #f59e0b;
        }

        /* Advanced Filters */
        .advanced-filters-wrapper {
          margin-top: 0.75rem;
        }

        .advanced-filters-toggle {
          background: transparent;
          border: none;
          color: var(--gov-blue);
          font-weight: 600;
          font-size: 0.8125rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 0.375rem;
          padding: 0.375rem 0;
          transition: all 0.2s ease;
        }

        .advanced-filters-toggle:hover {
          color: var(--gov-navy);
        }

        .advanced-filters-toggle svg {
          transition: transform 0.3s ease;
        }

        .advanced-filters-toggle.open svg:last-child {
          transform: rotate(180deg);
        }

        .filter-controls {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 0.75rem;
          margin-top: 0.75rem;
          animation: slideDown 0.3s ease;
        }

        .filter-group {
          display: flex;
          flex-direction: column;
          gap: 0.375rem;
        }

        .filter-label {
          font-size: 0.75rem;
          font-weight: 600;
          color: var(--gov-text-secondary);
          text-transform: uppercase;
          letter-spacing: 0.3px;
        }

        .filter-select {
          padding: 0.5rem 0.75rem;
          border: 1px solid var(--gov-border);
          border-radius: 6px;
          font-size: 0.875rem;
          font-family: inherit;
          transition: all 0.2s ease;
          background: white;
          cursor: pointer;
        }

        .filter-select:focus {
          outline: none;
          border-color: var(--gov-blue);
          box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.08);
        }

        .filter-select:hover {
          border-color: var(--gov-text-secondary);
        }

        .clear-filters-btn {
          padding: 0.625rem 1.25rem;
          background: #dc2626;
          color: white;
          border: none;
          border-radius: 6px;
          font-weight: 600;
          font-size: 0.875rem;
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.375rem;
        }

        .clear-filters-btn:hover {
          background: #b91c1c;
          transform: translateY(-1px);
        }

        .clear-filters-btn:active {
          transform: translateY(0);
        }

        .active-filters {
          margin-top: 0.75rem;
          padding-top: 0.75rem;
          border-top: 1px solid var(--gov-border);
          display: flex;
          flex-wrap: wrap;
          gap: 0.375rem;
          align-items: center;
        }

        .active-filters-label {
          font-size: 0.75rem;
          font-weight: 600;
          color: var(--gov-text-secondary);
        }

        .filter-badge {
          display: inline-flex;
          align-items: center;
          gap: 0.375rem;
          padding: 0.25rem 0.625rem;
          background: var(--gov-blue);
          color: white;
          border-radius: 12px;
          font-size: 0.75rem;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .filter-badge:hover {
          transform: scale(1.05);
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
        }

        .filter-badge.search { background: #34a853; }
        .filter-badge.block { background: var(--gov-navy); }
        .filter-badge.gp { background: var(--gov-saffron); }

        /* Content Section */
        .content-section {
          padding: 2rem;
        }

        .section-block {
          margin-bottom: 3rem;
        }

        .section-header {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 1.5rem;
          padding-bottom: 1rem;
          border-bottom: 3px solid var(--gov-navy);
        }

        .section-title {
          font-family: 'Tiro Devanagari Hindi', serif;
          font-size: 1.75rem;
          font-weight: 600;
          color: var(--gov-navy);
          margin: 0;
        }

        .section-count {
          background: var(--gov-navy);
          color: white;
          padding: 0.25rem 0.75rem;
          border-radius: 20px;
          font-size: 0.875rem;
          font-weight: 600;
        }

        /* Person Cards */
        .person-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
          gap: 1.5rem;
        }

        .person-card {
          background: var(--gov-card-bg);
          border-radius: 12px;
          border: 1px solid var(--gov-border);
          overflow: hidden;
          transition: all 0.3s ease;
          animation: fadeInUp 0.5s ease backwards;
        }

        .person-card:hover {
          box-shadow: var(--gov-shadow-hover);
          transform: translateY(-4px);
          border-color: var(--gov-blue);
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .person-card:nth-child(1) { animation-delay: 0.05s; }
        .person-card:nth-child(2) { animation-delay: 0.1s; }
        .person-card:nth-child(3) { animation-delay: 0.15s; }
        .person-card:nth-child(4) { animation-delay: 0.2s; }
        .person-card:nth-child(5) { animation-delay: 0.25s; }
        .person-card:nth-child(6) { animation-delay: 0.3s; }

        .person-card-inner {
          padding: 1.5rem;
          display: flex;
          gap: 1.25rem;
        }

        .person-photo {
          flex-shrink: 0;
        }

        .person-photo img,
        .person-avatar {
          width: 90px;
          height: 90px;
          border-radius: 50%;
          object-fit: cover;
        }

        .person-avatar {
          background: linear-gradient(135deg, var(--gov-blue) 0%, var(--gov-navy) 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
        }

        .person-details {
          flex: 1;
          min-width: 0;
        }

        .person-name {
          font-size: 1.25rem;
          font-weight: 600;
          color: var(--gov-navy);
          margin-bottom: 0.5rem;
          line-height: 1.3;
        }

        .person-location {
          display: inline-flex;
          align-items: center;
          gap: 0.375rem;
          padding: 0.25rem 0.75rem;
          background: rgba(26, 115, 232, 0.1);
          color: var(--gov-blue);
          border-radius: 20px;
          font-size: 0.875rem;
          font-weight: 500;
          margin-bottom: 0.5rem;
        }

        .person-gp {
          font-size: 0.875rem;
          color: var(--gov-text-secondary);
          margin-bottom: 0.75rem;
        }

        .person-contact {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
          margin: 0.75rem 0;
        }

        .contact-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.875rem;
          color: var(--gov-text-secondary);
        }

        .contact-item svg {
          flex-shrink: 0;
          color: var(--gov-blue);
        }

        .contact-item a {
          color: inherit;
          text-decoration: none;
          word-break: break-word;
          transition: color 0.2s ease;
        }

        .contact-item a:hover {
          color: var(--gov-blue);
          text-decoration: underline;
        }

        .person-social {
          display: flex;
          gap: 0.5rem;
          margin-top: 0.75rem;
        }

        .social-link {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: var(--gov-bg);
          color: var(--gov-text);
          text-decoration: none;
          transition: all 0.2s ease;
          border: 1px solid var(--gov-border);
        }

        .social-link:hover {
          transform: translateY(-2px);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        }

        .social-link.facebook:hover {
          background: #1877f2;
          color: white;
          border-color: #1877f2;
        }

        .social-link.twitter:hover {
          background: #1da1f2;
          color: white;
          border-color: #1da1f2;
        }

        .social-link.linkedin:hover {
          background: #0a66c2;
          color: white;
          border-color: #0a66c2;
        }

        .social-link.instagram:hover {
          background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
          color: white;
          border-color: transparent;
        }

        .empty-state {
          text-align: center;
          padding: 3rem 2rem;
          background: var(--gov-card-bg);
          border-radius: 12px;
          border: 1px dashed var(--gov-border);
        }

        .empty-state-icon {
          width: 64px;
          height: 64px;
          margin: 0 auto 1rem;
          background: var(--gov-bg);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--gov-text-secondary);
        }

        .empty-state-text {
          color: var(--gov-text-secondary);
          font-size: 1.125rem;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .page-header {
            padding: 1.5rem 1rem 1.25rem;
          }

          .page-title {
            font-size: 1.5rem;
          }

          .page-subtitle {
            font-size: 0.875rem;
          }

          .results-summary {
            font-size: 0.8125rem;
            padding: 0.625rem 1rem;
            margin-top: 0.875rem;
          }

          .results-summary strong {
            font-size: 1.25rem;
          }

          .filter-section {
            margin: -1rem 1rem 1rem;
            padding: 1rem;
          }

          .filter-title {
            font-size: 0.8125rem;
          }

          .search-bar-container {
            flex-direction: column;
            gap: 0.5rem;
          }

          .filter-input {
            padding: 0.625rem 2rem 0.625rem 2.25rem;
            font-size: 0.875rem;
          }

          .search-icon-left {
            left: 0.625rem;
          }

          .clear-search-btn {
            right: 0.625rem;
          }

          .search-btn {
            width: 100%;
            justify-content: center;
            padding: 0.625rem 1rem;
            font-size: 0.875rem;
          }

          .search-status {
            padding: 0.625rem 0.75rem;
            gap: 0.5rem;
          }

          .search-status-icon {
            width: 28px;
            height: 28px;
          }

          .search-status-icon svg {
            width: 18px;
            height: 18px;
          }

          .search-status-title {
            font-size: 0.75rem;
          }

          .search-status-text {
            font-size: 0.75rem;
          }

          .advanced-filters-toggle {
            font-size: 0.75rem;
          }

          .filter-controls {
            grid-template-columns: 1fr;
            gap: 0.625rem;
          }

          .filter-label {
            font-size: 0.6875rem;
          }

          .filter-select {
            padding: 0.5rem 0.625rem;
            font-size: 0.8125rem;
          }

          .clear-filters-btn {
            width: 100%;
            padding: 0.625rem 1rem;
            font-size: 0.8125rem;
          }

          .person-grid {
            grid-template-columns: 1fr;
            gap: 1rem;
          }

          .person-card-inner {
            flex-direction: column;
            align-items: center;
            text-align: center;
            padding: 1.25rem;
          }

          .person-photo img,
          .person-avatar {
            width: 80px;
            height: 80px;
          }

          .person-name {
            font-size: 1.125rem;
          }

          .person-contact {
            align-items: center;
          }

          .person-social {
            justify-content: center;
          }

          .content-section {
            padding: 1rem;
          }

          .section-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.5rem;
          }

          .section-title {
            font-size: 1.5rem;
          }

          .active-filters {
            margin-top: 0.625rem;
            padding-top: 0.625rem;
          }

          .filter-badge {
            font-size: 0.6875rem;
            padding: 0.25rem 0.5rem;
          }
        }

        @media (max-width: 480px) {
          .page-title {
            font-size: 1.375rem;
          }

          .page-subtitle {
            font-size: 0.8125rem;
          }

          .filter-input {
            padding: 0.5rem 1.75rem 0.5rem 2rem;
            font-size: 0.8125rem;
          }

          .search-btn {
            font-size: 0.8125rem;
            padding: 0.5rem 0.875rem;
          }

          .filter-section {
            padding: 0.875rem;
            border-radius: 6px;
          }

          .person-card {
            border-radius: 6px;
          }

          .section-title {
            font-size: 1.375rem;
          }
        }

        @media (min-width: 769px) and (max-width: 1024px) {
          .filter-section {
            margin: -1.5rem 1.5rem 1.5rem;
            padding: 1.25rem;
          }

          .search-bar-container {
            gap: 0.625rem;
          }

          .search-btn {
            padding: 0.625rem 1rem;
            font-size: 0.875rem;
          }

          .filter-controls {
            grid-template-columns: repeat(2, 1fr);
          }

          .filter-controls > :last-child {
            grid-column: 1 / -1;
          }

          .person-grid {
            grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          }
        }

        @media (min-width: 1025px) and (max-width: 1280px) {
          .filter-section {
            padding: 1.25rem 1.5rem;
          }

          .filter-controls {
            grid-template-columns: repeat(2, 1fr) auto;
          }

          .person-grid {
            grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
          }
        }
      `}</style>

      <div className="whos-who-container">
        {/* Header */}
        <div className="page-header">
          <h1 className="page-title">निर्देशिका / Who's Who</h1>
          <p className="page-subtitle">Social Audit Personnel Directory</p>
          <div className="results-summary">
            <strong>{getTotalCount()}</strong>
            <span>Personnel Listed</span>
          </div>
        </div>

        {/* Filter Section */}
        <div className="filter-section">
          <div className="filter-header">
            <div className="filter-title">
              <Search size={16} />
              Search Directory
            </div>
          </div>
          
          {/* Search Bar */}
          <div className="search-bar-wrapper">
            <div className="search-bar-container">
              <div className="search-input-wrapper">
                <Search size={20} className="search-icon-left" />
                <input
                  type="text"
                  className="filter-input"
                  placeholder="Search by name, email, block or gram panchayat..."
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setSearchPerformed(false);
                  }}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      performSearch();
                    }
                  }}
                />
                {searchQuery && (
                  <button 
                    className="clear-search-btn"
                    onClick={() => {
                      setSearchQuery('');
                      setSearchPerformed(false);
                    }}
                    title="Clear search"
                  >
                    <X size={18} />
                  </button>
                )}
              </div>
              <button className="search-btn" onClick={performSearch}>
                <Search size={16} />
                Search
              </button>
            </div>

            {/* Search Status Output */}
            {searchPerformed && (
              <div className={`search-status ${resultsCount > 0 ? 'success' : 'warning'}`}>
                <div className="search-status-icon">
                  {resultsCount > 0 ? (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  ) : (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="8" x2="12" y2="12"></line>
                      <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                  )}
                </div>
                <div className="search-status-content">
                  <div className="search-status-title">
                    {resultsCount > 0 ? 'Search Results Found' : 'No Results Found'}
                  </div>
                  <div className="search-status-text">
                    {resultsCount > 0 ? (
                      <>
                        Found <span className="search-status-count">{resultsCount}</span> personnel matching your search criteria
                        {searchQuery && ` for "${searchQuery}"`}
                        {blockFilter && ` in ${blockFilter}`}
                        {gpFilter && ` under ${gpFilter}`}.
                      </>
                    ) : (
                      <>
                        No personnel found matching your search criteria. Try adjusting your filters or search terms.
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Advanced Filters Toggle */}
          <div className="advanced-filters-wrapper">
            <button 
              className={`advanced-filters-toggle ${showAdvancedFilters ? 'open' : ''}`}
              onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
            >
              <Filter size={16} />
              {showAdvancedFilters ? 'Hide Advanced Filters' : 'Show Advanced Filters'}
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </button>

            {/* Advanced Filter Controls */}
            {showAdvancedFilters && (
              <div className="filter-controls">
                <div className="filter-group">
                  <label className="filter-label">Filter by Block</label>
                  <select
                    className="filter-select"
                    value={blockFilter}
                    onChange={(e) => {
                      setBlockFilter(e.target.value);
                      setSearchPerformed(false);
                    }}
                  >
                    <option value="">All Blocks</option>
                    {allBlocks.map(block => (
                      <option key={block} value={block}>{block}</option>
                    ))}
                  </select>
                </div>

                <div className="filter-group">
                  <label className="filter-label">Filter by Gram Panchayat</label>
                  <select
                    className="filter-select"
                    value={gpFilter}
                    onChange={(e) => {
                      setGpFilter(e.target.value);
                      setSearchPerformed(false);
                    }}
                  >
                   <option value="">All Gram Panchayats</option>
{filteredGPs.map(gp => (
  <option key={gp} value={gp}>{gp}</option>
))}
                  </select>
                </div>

                <button className="clear-filters-btn" onClick={clearFilters}>
                  <X size={18} />
                  Clear All Filters
                </button>
              </div>
            )}

            {/* Active Filters Display */}
            {hasActiveFilters && (
              <div className="active-filters">
                <span className="active-filters-label">Active Filters:</span>
                {searchQuery && (
                  <span 
                    className="filter-badge search"
                    onClick={() => setSearchQuery('')}
                    title="Click to remove"
                  >
                    Search: {searchQuery}
                    <X size={14} />
                  </span>
                )}
                {blockFilter && (
                  <span 
                    className="filter-badge block"
                    onClick={() => setBlockFilter('')}
                    title="Click to remove"
                  >
                    Block: {blockFilter}
                    <X size={14} />
                  </span>
                )}
                {gpFilter && (
                  <span 
                    className="filter-badge gp"
                    onClick={() => setGpFilter('')}
                    title="Click to remove"
                  >
                    GP: {gpFilter}
                    <X size={14} />
                  </span>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Content */}
        <div className="content-section">
          {/* Block Social Auditor Section */}
          <section id="blocksocialaudit" className="section-block">
            <div className="section-header">
              <h2 className="section-title">Block Social Auditors</h2>
              <span className="section-count">
                {filterPeople(people.blocksocialaudit).length}
              </span>
            </div>
            {filterPeople(people.blocksocialaudit).length > 0 ? (
              <div className="person-grid">
                {filterPeople(people.blocksocialaudit).map(person => (
                  <PersonCard key={person.id} person={person} showGP={false} />
                ))}
              </div>
            ) : (
              <div className="empty-state">
                <div className="empty-state-icon">
                  <Search size={32} />
                </div>
                <p className="empty-state-text">
                  No Block Social Auditors found matching your filters
                </p>
              </div>
            )}
          </section>

          {/* Village Resource Person Section */}
          <section id="vrp" className="section-block">
            <div className="section-header">
              <h2 className="section-title">Village Resource Persons</h2>
              <span className="section-count">
                {filterPeople(people.vrp).length}
              </span>
            </div>
            {filterPeople(people.vrp).length > 0 ? (
              <div className="person-grid">
                {filterPeople(people.vrp).map(person => (
                  <PersonCard key={person.id} person={person} showGP={true} />
                ))}
              </div>
            ) : (
              <div className="empty-state">
                <div className="empty-state-icon">
                  <Search size={32} />
                </div>
                <p className="empty-state-text">
                  No Village Resource Persons found matching your filters
                </p>
              </div>
            )}
          </section>

          {/* Other Section */}
          <section id="other" className="section-block">
            <div className="section-header">
              <h2 className="section-title">Other Personnel</h2>
              <span className="section-count">
                {filterOtherPeople(people.other).length}
              </span>
            </div>
            {filterOtherPeople(people.other).length > 0 ? (
              <div className="person-grid">
                {filterOtherPeople(people.other).map(person => (
                  <PersonCard key={person.id} person={person} showGP={false} />
                ))}
              </div>
            ) : (
              <div className="empty-state">
                <div className="empty-state-icon">
                  <Search size={32} />
                </div>
                <p className="empty-state-text">
                  No Other Personnel found matching your filters
                </p>
              </div>
            )}
          </section>
        </div>
      </div>
    </>
  );
}

export default WhosWho;